{
  "common": {
    "back": "Back",
    "help": "Help",
    "logIn": "Log in",
    "myMemberPage": "My voter page",
    "continue": "Continue",
    "loading": "Loading...",
    "tryAgain": "Try again",
    "show": "Show",
    "hide": "Hide",
    "close": "Close",
    "why": "Why?",
    "stepNOfM": "Step {{n}} of {{m}}",
    "skipToContent": "Skip to the main content",
    "somethingWrong": "Something went wrong. Please try again in a few minutes.",
    "alreadyRegistered": "Already registered?",
    "theme": {
      "label": "Theme",
      "system": "System",
      "light": "Light",
      "dark": "Dark",
      "current": "Theme: {{choice}}"
    }
  },
  "steps": {
    "about": "About you",
    "email": "Check your email",
    "place": "Where do you live?",
    "document": "Your identity document",
    "face": "Face check"
  },
  "welcome": {
    "title": "Register as a voter with {{org}}",
    "intro": "We check that every new voter:",
    "check1": "is a real person",
    "check2": "joins only once",
    "check3": "is 17 or older",
    "check4": "lives where they say",
    "ageNote": "If your age is not clear, a person confirms it. You are not turned away for that.",
    "duration": "About <b>5 minutes</b>",
    "faqLink": "Read the FAQ",
    "start": "Start",
    "resume": "Continue where you stopped",
    "startAgain": "Start a new registration instead",
    "sessionEnded": "Your registration session ended. Start again with the same email and we will email you a link back to your step.",
    "recentDevices": "This link works on recent phones and computers.",
    "ownEmail": "Each voter needs their own email address.",
    "theSteps": "The {{n}} steps",
    "step_about": "Your name and email",
    "step_email": "A code we send to your email",
    "step_place": "Where you live",
    "step_document": "A photo of your identity document",
    "step_face": "A short face check with your camera"
  },
  "notActive": {
    "title": "This registration link is not active.",
    "instead": "Please use this link instead:",
    "go": "Go to the registration"
  },
  "about": {
    "name": "Your name",
    "email": "Your email address",
    "emailHint": "We send a code to this email.",
    "consent": "I have read <a>how {{org}} uses my information.</a>",
    "continue": "Continue",
    "errName": "Please write your name.",
    "errEmail": "This email address does not look right. Please check it.",
    "errConsent": "Please tick the box to continue."
  },
  "email": {
    "sentTo": "We sent a 6-number code to <b>{{email}}</b>.",
    "sentToNoAddress": "We sent a 6-number code to your email.",
    "code": "Code",
    "continue": "Continue",
    "resend": "Send the code again",
    "resendWait": "We just sent it. You can ask again in {{seconds}} seconds.",
    "resent": "We sent a new code.",
    "wrongEmail": "I wrote the wrong email",
    "noCode": "No code?",
    "errNotRight": "This code is not right. Please check the numbers and try again.",
    "errNotRightLeft_one": "This code is not right. Please check the numbers and try again. (You can try {{count}} more time.)",
    "errNotRightLeft_other": "This code is not right. Please check the numbers and try again. (You can try {{count}} more times.)",
    "errEmpty": "Please type the 6 numbers from the email.",
    "errExpired": "This code is too old. Press 'Send the code again'.",
    "errTooMany": "Too many tries. Please wait 15 minutes and ask for a new code."
  },
  "confirm": {
    "title": "Confirm your email",
    "pressFor": "Press the button to confirm <b>{{email}}</b> and continue your registration.",
    "pressForNoAddress": "Press the button to confirm your email and continue your registration.",
    "button": "Confirm my email",
    "oldLink": "This link is too old or was already used. Go back to the registration page and type the code, or ask for a new code.",
    "goBack": "Go to the registration"
  },
  "continuePage": {
    "title": "Continue your registration",
    "text": "Press the button to continue where you stopped.",
    "button": "Continue",
    "oldLink": "This link is too old or was already used. Open the registration page and start again. If you are already a voter, the email we send you will say so."
  },
  "place": {
    "confirmed": "Thank you. Your email is confirmed.",
    "label": "City, town or village",
    "hint": "Where you live, not where you are today.",
    "geonames": "Place names: <a>GeoNames</a> (CC BY 4.0)",
    "listLabel": "Places that match",
    "notInList": "That place is not in the list",
    "notInListText": "Choose the nearest town and write the name of your place:",
    "noteLabel": "The name of your place",
    "noResults": "No place found. Check the spelling, or press \"That place is not in the list\".",
    "errChoose": "Please choose your place from the list.",
    "searching": "Searching...",
    "locTitle": "Confirm your location",
    "locTitleOptional": "Confirm your location (optional)",
    "locWhy": "We check once that you are near the place you chose. We keep only a rough area (about 1 km), until 30 days after our decision.",
    "locRequired": "If you cannot share it, a person will check your registration.",
    "locStrict": "You need to share your location to continue.",
    "locShare": "Share my location",
    "locFinding": "Finding your location…",
    "locFindingAccuracy": "Finding your location… {{accuracy}}",
    "locDone": "Thank you. We have your location.",
    "locApprox": "Your location is only approximate ({{accuracy}}). Turn on precise location and try again:",
    "locApproxIphone": "iPhone: Settings, Privacy & Security, Location Services, Safari Websites: turn on \"Precise Location\".",
    "locApproxAndroid": "Android: touch the symbol left of the page address, then \"Permissions\", \"Location\": turn on \"Use precise location\".",
    "locBlocked": "Location is blocked for this page.",
    "locNotFound": "We could not find your location.",
    "locUnsupported": "This browser cannot share a location. Try another browser, or your phone.",
    "locTryAgain": "Try again",
    "locCant": "I can't share my location",
    "locCantDone": "That is fine. A person will check your registration.",
    "locSkip": "Continue without it",
    "locSkipped": "You skipped this. That is fine.",
    "errLocation": "Please share your location first.",
    "errLocationOrCant": "Please share your location, or press \"I can't share my location\".",
    "gpsHow": "Show me how to allow it",
    "continue": "Continue"
  },
  "password": {
    "label": "Password",
    "hintShort": "At least 8 letters or numbers, for example: blue house on the hill.",
    "tipsTitle": "Password tips",
    "tips": "Spaces are allowed. A short sentence is easy to remember. Write it down somewhere safe. If you forget it, we can send you a link by email to choose a new one.",
    "errShort": "Please use at least 8 letters or numbers.",
    "errWeak": "This password is too easy to guess. Please choose a longer one, for example a short sentence."
  },
  "help": {
    "title": "Help",
    "contact": "Call or WhatsApp {{phone}}, or write to {{contact}}.",
    "contactNoPhone": "Write to {{contact}}.",
    "continueIntro": "Want to finish later, or on another phone or computer?",
    "continueButton": "Email me a link to continue",
    "continueDone": "We sent you an email. Press the button in it to continue where you stopped. The link works for 30 days.",
    "deleteIntro": "Want to stop and delete what you gave us?",
    "deleteButton": "Send me a link to delete my registration",
    "deleteDone": "We sent you an email. Press the button in it to delete your registration. The link works for 1 hour."
  },
  "faq": {
    "group": {
      "registering": "Registering",
      "code": "The email code",
      "place": "Where you live",
      "face": "The face check",
      "document": "Identity document",
      "account": "Signing in and your account",
      "finish": "Finish later or stop"
    },
    "steps": {
      "q": "What are the steps?",
      "after": "About 5 minutes in all."
    },
    "needs": {
      "q": "What do I need?",
      "a": "Your own email address, a phone or a computer with a camera, and a place with good light."
    },
    "ownEmail": {
      "q": "Why does each voter need their own email?",
      "a": "We tell voters apart by email. If you share an address with someone who is already a voter, your registration cannot go through: use another address. If you joined before, press \"Log in\" at the top, use the email you used the first time and press \"Email me a sign-in link\"."
    },
    "later": {
      "q": "Can I finish later, or on another phone or computer?",
      "a": "Yes. Press \"Email me a link to continue\" at the end of this help. The link takes you back to your step; it works for 30 days. If this page closes, you can also open the registration page again and type the same email.",
      "aOutside": "Yes. Open the registration page again and type the same email: we email you a link back to your step."
    },
    "code": {
      "q": "The code has not arrived",
      "a": "It can take 1 or 2 minutes. Look in \"Spam\" or \"Junk\" (in Gmail: the three lines at the top left, then \"Spam\"). The subject of the email starts with the code. Still nothing? Press \"Send the code again\", or check the address with \"I wrote the wrong email\"."
    },
    "codeButton": {
      "q": "Can I press the button in the email instead of typing?",
      "a": "Yes. The email has a button, <b>\"Confirm my email\"</b>. Press it, and press <b>\"Confirm my email\"</b> on the page that opens. It takes you to the next step. Or keep this page open and type the 6 numbers."
    },
    "place": {
      "q": "Why do you ask where I live?",
      "a": "We compare your place with where your internet connection seems to come from. If the two are far apart, a person checks it; you are not rejected for that. If you use a VPN (a program that hides where your internet comes from), turn it off for this step."
    },
    "location": {
      "q": "Why share my location, and what do you keep?",
      "a": "We check once that you are near the place you chose. We keep only a rough area (about 1 km), until 30 days after our decision. Your phone or computer asks first: press \"Allow\". If you cannot share it, a person checks your registration instead. A computer may only know a rough place; a phone is better for this step."
    },
    "locationAllow": {
      "q": "I pressed \"Block\" on the location. How do I allow it?"
    },
    "face": {
      "q": "Why a face check?",
      "a": "It confirms that you are a real person (not a photo), that you have not joined before, and it estimates your age. If a document is asked for next, we also check that the photo on it is you. If the age is not clear, a person looks at your registration. You are not rejected for that."
    },
    "faceData": {
      "q": "What do you keep from my face?",
      "more": "Details: <a>how {{org}} uses your information</a>."
    },
    "faceStart": {
      "q": "What happens when I press Start?",
      "generic": "The check uses your camera, on a phone or on a computer. It takes a few seconds.",
      "permission": "Your phone or computer will ask: \"Allow this page to use your camera?\" Press <b>Allow</b>. We use the camera only during the check."
    },
    "tips": {
      "q": "Tips for a good check"
    },
    "cameraAllow": {
      "q": "I pressed \"Block\" on the camera. How do I allow it?",
      "intro": "Do this, then press \"Try again\". If the page does not change, reload it."
    },
    "faceFailed": {
      "q": "The check did not work. What now?",
      "a": "Try again with more light; go into the shade if the sun is strong, and hold still. After your last try a person checks your registration by hand. This is not a rejection."
    },
    "document": {
      "q": "Why a document, and what do you keep?",
      "a": "To check that your document is real and that it is yours: we compare the photo on it with the face check you just did. We keep your first name, your year of birth, whether and how your document was checked, and the result of each check. We never keep its number, your full date of birth or your address. We keep the photos of your face check and of your document only if a person has to review your registration: encrypted, and deleted when the review ends, at the latest {{days}} days after the review starts. Details: <a>Identity document, in the privacy page</a>. If you cannot use a document, press \"I can't use a document\" and a person verifies you by video call."
    },
    "documentStart": {
      "q": "What happens when I press Continue?",
      "a": "The scan opens on the page of the company named in the box. It looks different from this page. When you finish, you come back here by yourself."
    },
    "password": {
      "q": "What makes a good password?"
    },
    "forgot": {
      "q": "How do I sign in again?",
      "a": "On the log-in page write your email and press \"Email me a sign-in link\". We send a link and a 6-digit code to that address. Both work for 15 minutes, one time. Do not forward that email to anyone."
    },
    "delete": {
      "q": "Can I delete what I gave you?",
      "a": "Yes. While you register, press \"Send me a link to delete my registration\" at the end of this help. As a voter, open \"My data\" on your voter page: you can download or delete everything there.",
      "aOutside": "Yes. As a voter, open \"My data\" on your voter page: you can download or delete everything there. While you register, this help offers a link to delete your registration once your email is confirmed."
    }
  },
  "cameraHelp": {
    "android": "Phone with Android, in Chrome",
    "androidSteps": [
      "Touch the small symbol to the left of the page address at the top (a lock or sliders).",
      "Touch \"Permissions\", then \"Camera\", then \"Allow\".",
      "If \"Camera\" is not there: open the phone's Settings, then Apps, then Chrome, then Permissions, then Camera, then \"Allow only while using the app\"."
    ],
    "iphone": "iPhone or iPad, in Safari",
    "iphoneSteps": [
      "Touch \"aA\" at the left of the page address.",
      "Touch \"Website Settings\", then \"Camera\", then \"Allow\".",
      "Still not working: open the phone's Settings, then Safari, then Camera, and choose \"Ask\" or \"Allow\"."
    ],
    "chrome": "Computer, in Chrome",
    "chromeSteps": [
      "Click the small symbol to the left of the page address (a lock or a camera).",
      "Click \"Site settings\". Next to \"Camera\", choose \"Allow\".",
      "Reload the page."
    ],
    "edge": "Computer, in Edge",
    "edgeSteps": [
      "Click the lock to the left of the page address.",
      "Click \"Permissions for this site\". Next to \"Camera\", choose \"Allow\".",
      "Reload the page."
    ],
    "firefox": "Computer, in Firefox",
    "firefoxSteps": [
      "Click the camera symbol to the left of the page address.",
      "Next to \"Blocked\", click the small \"x\" to remove it.",
      "Reload the page and press \"Allow\" when it asks."
    ],
    "windows": "Windows laptop: the camera still does not open",
    "windowsSteps": [
      "Close other programs that may use the camera (for example Zoom, Teams or Skype).",
      "Press the Start button, open Settings, then Privacy and security, then Camera.",
      "Turn on \"Camera access\", \"Let apps access your camera\" and \"Let desktop apps access your camera\".",
      "Reload this page."
    ],
    "noCamera": "No camera at all?",
    "noCameraText": "Use a phone with a camera. Go back to Help and press \"Email me a link to continue\". Open that email on the phone and press \"Continue my registration\". You will come back to this step.",
    "noCameraTextLogin": "Use a phone with a camera. Log in there with a link we email you."
  },
  "locationHelp": {
    "allow": "To allow it after pressing \"Block\":",
    "android": "<i>Android, Chrome:</i> touch the symbol left of the page address, then \"Permissions\", then \"Location\", then \"Allow\".",
    "iphone": "<i>iPhone, Safari:</i> touch \"aA\", then \"Website Settings\", then \"Location\", then \"Allow\". If it is off for the whole phone: Settings, then Privacy and security, then Location Services, then Safari Websites.",
    "chromeEdge": "<i>Computer, Chrome or Edge:</i> click the symbol left of the page address, then \"Site settings\" (Edge: \"Permissions for this site\"), and next to \"Location\" choose \"Allow\". Reload the page.",
    "firefox": "<i>Computer, Firefox:</i> click the symbol left of the page address, click the \"x\" next to \"Blocked\", and reload.",
    "preciseTitle": "If it says your location is only approximate:",
    "preciseIphone": "<i>iPhone:</i> Settings, then Privacy & Security, then Location Services, then Safari Websites: turn on \"Precise Location\".",
    "preciseAndroid": "<i>Android, Chrome:</i> touch the symbol left of the page address, then \"Permissions\", then \"Location\": turn on \"Use precise location\"."
  },
  "unsubscribe": {
    "title": "Stop messages from {{org}}?",
    "text": "Press the button to stop messages from {{org}} to <b>{{email}}</b>.",
    "button": "Stop the messages",
    "already": "Messages to <b>{{email}}</b> are already stopped.",
    "done": "Done. We will not send you messages any more.",
    "badLink": "This link is not valid or is too old. To stop our messages, write to <a>{{contact}}</a>.",
    "toStart": "Go to the start"
  },
  "notFound": {
    "title": "This page does not exist",
    "text": "The address may be mistyped, or the page has moved.",
    "member": "Go to my voter page",
    "start": "Go to the start"
  },
  "footer": {
    "privacyPolicy": "Privacy Policy",
    "vocdoni": "vocdoni.io"
  },
  "privacy": {
    "title": "Privacy",
    "updatedNote": "How {{org}} uses your information when you register as a voter.",
    "controllerTitle": "Who is responsible",
    "controller": "The controller of your data is {{controller}}.",
    "processorTitle": "Who runs the service for the controller",
    "processor": "The service is run by Synergize S.L. (commercial name Vocdoni), as processor, contact info@synergize.dev.",
    "purposesTitle": "What we use your information for, and why we may",
    "purposes": [
      "Your name, email and place: to register and keep your registration. Legal basis: your consent.",
      "Your face (a face template, not a photo): to check that you are a real person, that you join only once and to guess your age. If a person has to review your registration, we also keep the photo of your face check and the photos of your document for that review (see \"How long we keep it\"). Legal basis: your explicit consent (Article 9(2)(a) GDPR). You can withdraw it by deleting your data.",
      "The place your internet connection seems to come from (from your IP address): to compare it with the place you chose, and to prevent fraud, including a digest of blocked email addresses that cannot be turned back into the address. Legal basis: our legitimate interest in fair voter registration and in preventing fraud.",
      "Your location from your phone or computer, once at step 3: to check that you are near the place you chose. Legal basis: steps before you register as a voter and our legitimate interest in a fair voter registration (Article 6(1)(b) and (f) GDPR). Your browser asks you first; if you cannot share it, a person checks your registration instead."
    ],
    "recipientsTitle": "Who receives your information",
    "recipientsIntro": "Only the companies below receive information about you, and only for the purpose shown. This list follows what we really use.",
    "recipientsNow": "In use now",
    "recipientsPast": "Used in the past (may still hold data)",
    "recipientsNone": "None.",
    "recipientRegion": "Where: {{region}}",
    "processorsTitle": "Companies that run the service",
    "sourcesTitle": "Lists kept on our own server (they receive nothing about you)",
    "reviewTitle": "People who look at your registration",
    "review": "When your registration needs a person to look at it (for example when we are not sure about your age, your place or your face check), authorized administrators of {{org}} may see the photo of your face check and the photos of your document that we keep for that review, and the photos and the video that the company doing the check keeps for you, for providers that keep them. They can see them only until they decide. There is one administrator role: every administrator can see them, every view is logged, and each photo carries a watermark with the name of the person looking. The watermark is a deterrent; the log is the control.",
    "retentionTitle": "How long we keep it",
    "retention": [
      "We never store a video of your face. The pictures of the check are held in memory only while the face template is made, and then deleted.",
      "If a person has to review your registration, we keep the photo of your face check and the photos of your document, encrypted, so that person can see them. We delete them when the review ends, at the latest {{days}} days after the review starts. A photo deleted from our database stays in our backups until they expire, at most 30 days.",
      "The company that does the check keeps its session until our decision. If a person has to look at your registration, until that person decides. At most 30 days.",
      "The face template is kept while your registration exists: while you are a voter, and also after a rejection, so the same face cannot register again with another email. It is deleted when you delete your data, or when a registration you did not finish is deleted.",
      "Your IP address is kept for 30 days after our decision, then shortened so it no longer points to you.",
      "Your location from your phone or computer is kept only as a rough area (about 1 km) and is deleted 30 days after our decision. What we concluded from it (for example \"within the area\") is kept while you are a voter.",
      "Registrations that you do not finish are deleted after 24 hours (before the email is confirmed) or 30 days (later).",
      "To sign you in we email you a link and a code. We keep only a scrambled copy of them, for 15 minutes or until you use them, and then delete it. A password is optional: if you set one, we keep only a scrambled copy of it.",
      "Anonymous statistics about the checks are kept for 1 year.",
      "Backups are kept for at most 30 days."
    ],
    "deletionTitle": "When you delete your data",
    "deletion": "When you delete your data, we delete your name, your email, your place and your face template at once, and we ask the company that did the check to delete what it has. This must be done within 30 days at the latest. If a company is late, we keep asking until it is done, and the administrators see it as overdue. Amazon Web Services cannot delete single checks: we send it a request and keep a note of the request until it answers.",
    "doc": {
      "title": "Identity document",
      "intro": "{{org}} may ask you to photograph an identity document when you register. This part says what happens to it. The company that does the check is named before you tick the box, and listed under \"Who receives your information\".",
      "basisTitle": "Why, and your choice",
      "basis": "To check that your document is real and that it is yours. Legal basis: your explicit consent (Article 6(1)(a) and 9(2)(a) GDPR). The box is never ticked for you. You can say no: use \"I can't use a document\" and a person will call you instead. If the company or the text changes, we ask you again.",
      "readTitle": "What the check reads",
      "read": "The company reads your document on its own page: your name and whether the document looks genuine. It sends us the result and the small photo from your document. Our own software compares that photo with your face check, in memory, and then discards it. The photo is never stored on its own: we keep only the photos of a registration that a person has to review (see \"What we keep\").",
      "keptTitle": "What we keep",
      "kept": [
        "Your first name only (for example \"Maria\"). We keep it instead of the name you typed. It is encrypted.",
        "Your year of birth only, never the full date.",
        "Your document status: checked or not, how (a company, or a person by video call), the day.",
        "The result of each check (for example \"looks genuine\") and how well the photo matched your face check, as a band and a number. It is encrypted.",
        "That you agreed, when, to which company and to which text.",
        "If you did not need a document: the reason, encrypted."
      ],
      "neverTitle": "What we never keep",
      "never": "A picture of your document, unless a person has to review your registration (then until the review ends, at the latest {{days}} days after the review starts, encrypted). Your document number or personal number. The machine-readable lines (MRZ). Your full date of birth (we keep only the year and that you are 17 or older). Your address, nationality, gender or place of birth. Your full name as printed on the document. The company's own answers.",
      "workingTitle": "While you register",
      "working": "While you register, we keep an encrypted working record of each try: the country and type of document you chose, the result of that try and the reference of the company's session. It counts your tries. It is deleted 30 days after the try ends and the company has deleted its session. The country and type of your document are not kept on your voter record.",
      "evidenceTitle": "24 hours",
      "evidence": "While you register, the result of the check waits as a sealed record for at most 24 hours. It is used once, for our first decision on your registration, and then it is used up. If it is not used, it is deleted after 24 hours.",
      "deletionTitle": "Deleted at the company",
      "deletion": "As soon as your check is over, we ask the company to delete its session and everything it holds about it. We aim for within 1 hour. If it does not confirm, we keep asking and the administrators are alerted. We keep the reference of the session, with no content, until the company confirms, and then 30 days.",
      "manualTitle": "Video call instead",
      "manual": "If you cannot or do not want to use a document, a person from {{org}} verifies you by video call. The person sees your document and you during the call. We keep only that it was done, by whom and when.",
      "withdrawTitle": "If you change your mind",
      "withdraw": "You can withdraw your consent at any time on your voter page (\"My data\"), or write to {{contact}}. If you are still registering, a person will call you, and the check results are deleted. If you are already a voter, the detailed results are deleted. The record that your document was checked and your first name stay.",
      "personTitle": "A person decides",
      "person": "No machine accepts or rejects you because of your document. When a check does not pass, a person looks at it and decides.",
      "exemptTitle": "When no document is needed",
      "exempt": "In some places {{org}} does not ask for a document if your location, your internet connection and your time zone all agree with the place you chose. A person still looks at the registration. This is a lower level of assurance than a checked document."
    },
    "rightsTitle": "Your rights",
    "rights": "You can ask to see, correct or delete your information, to limit how we use it, and to object. You can delete your data yourself from your voter page. You can also write to info@synergize.dev. You have the right to complain to your data protection authority (in Spain, the Agencia Española de Protección de Datos).",
    "contactTitle": "Contact",
    "contact": "Questions? Write to {{contact}} or to info@synergize.dev.",
    "contactSame": "Questions? Write to {{contact}}.",
    "creditsTitle": "Cookies and credits",
    "cookiesLink": "<a>Cookies</a>: the three strictly necessary cookies, and nothing else.",
    "credits": "Photo on the start and log-in pages: <a>Unsplash</a>."
  },
  "cookies": {
    "title": "Cookies",
    "intro": "This site uses only the cookies it needs to work. They are strictly necessary, so you do not need to accept anything and there is no cookie banner.",
    "listTitle": "The cookies",
    "member": "Voter session: keeps you signed in to your voter page, for up to 30 days of use and 90 days in all. \"Sign out\" ends it.",
    "registration": "Registration: keeps your place in the registration while you fill it in.",
    "admin": "Admin session: used only by the administrators of {{org}} when they log in.",
    "storageTitle": "What your browser also remembers",
    "storage": "While you fill in the registration, your browser also remembers your name, your email and the name of your place on this device, so a reload does not lose them. It never remembers your code. It is removed when you finish the step.",
    "none": "We use no cookies for advertising, tracking or statistics.",
    "theme": "If you pick a light or a dark theme, your browser remembers that choice on this device (the entry \"theme-preference\"). It is stored only when you pick one, it is never sent to us, and it is removed when you choose System again or clear the site data."
  },
  "face": {
    "intro": "A short camera check: are you a real person, 17 or older, and not already registered?",
    "review": "If it is not clear, a person checks it. You are not rejected for that.",
    "cameraHelpLink": "Camera help",
    "whatNext": "What happens next?",
    "consent": "I agree that {{org}} checks my face with {{provider}}, as explained above, and keeps my face template (not a photo) so each person registers once, and my photos during a review (at most {{days}} days).",
    "start": "Start the face check",
    "startHint": "Tick the consent box to start.",
    "handoverHosted1": "The face check opens on the page of {{provider}}, the company that does the check for {{org}}. It looks different from this page. That is normal. When you finish, you will come back here by yourself. If you do not come back, we will email you the result.",
    "handoverHosted2": "You can do this on a computer with a camera. You do not need a phone. If the page shows a square picture with dots (a QR code), you can scan it with a phone, or carry on with this computer.",
    "handoverOwn": "Our camera screen opens here, on this page. It works on a phone or on a computer with a camera. It takes a few seconds. Then we send the pictures to {{provider}}, the company that does the check for {{org}}. You stay on this page the whole time.",
    "handoverEmbedded": "The check of {{provider}}, the company that does the check for {{org}}, opens here, on this page. It uses your camera. It works on a phone or on a computer with a camera. It takes about 10 seconds. You stay on this page the whole time.",
    "stopped": "You stopped the check. This did not count as a try.",
    "opening": "Opening the face check...",
    "notActive": "This face check is not available now. Please try again later.",
    "unknownFlow": "Something went wrong before the check started. This did not count as a try. Please try again in a few minutes."
  },
  "aboutFace": {
    "keptForReview": "We do <b>not</b> keep any video of your face. The company that does the check for {{org}}, {{provider}}, deletes the photos and the video when the check is finished. If a person has to look at your registration, the company keeps them until that person decides, at most 30 days, and only that person can see them. We ask the company to delete them and we check that it did. If it is late, we keep asking until it is done.",
    "keptToRunService": "We do <b>not</b> keep any video of your face. {{provider}} makes a short video of your face for the check. We get one picture from the check. We make your face template from it and then delete the picture, unless a person has to review your registration (see below). {{provider}} does not use your video to improve its products. It may keep it for some time to run its service.",
    "notKept": "We do <b>not</b> keep any video of your face. During the check we take one or two pictures and send them to {{provider}}, the company that does the check for {{org}}. {{provider}} does not keep them. We make your face template from the first picture and then delete the pictures, unless a person has to review your registration (see below).",
    "generic": "We do <b>not</b> keep any video of your face.",
    "reviewMedia": "If a person has to review your registration, we keep the photo of your face check and the photos of your document, encrypted, so that person can see them. We delete them when the review ends, at the latest {{days}} days after the review starts.",
    "template": "We keep a <b>face template</b> (numbers, not a photo), encrypted, only to stop a second registration.",
    "delete": "You can delete your data, including your face template, at any time from your voter page."
  },
  "join": {
    "document": {
      "intro": "It takes about 2 minutes. We compare the photo on it with your face check.",
      "countryLabel": "Country of your document",
      "countryList": "Countries",
      "countryNone": "No country found. Try another spelling.",
      "classLabel": "Type of document you will scan",
      "class": {
        "passport": "Passport",
        "id_card": "Identity card",
        "driver_licence": "Driver's licence"
      },
      "hintIsrId": "Photograph only the front of your ID card. Do not include the appendix.",
      "hintTwoSides": "Have both sides ready.",
      "why": "We check that it is real and yours. If a person has to review your registration, we keep the photos of your document and of your face check, encrypted, until the review ends, at the latest {{days}} days after the review starts.",
      "consent": "I agree that {{provider}} checks my identity document for {{org}}.",
      "continue": "Continue to scan your document",
      "chooseHint": "Choose the country and the type of document.",
      "continueHint": "Tick the box to continue.",
      "opening": "Opening the scan...",
      "failed": "We could not read your document. Please try again.",
      "failedOurSide": "Something went wrong on our side. This did not count as a try. Please try again.",
      "failedExpired": "This document has expired. Please use another one.",
      "failedNotAccepted": "We cannot accept that document. Choose the country and type of a document we accept, then scan that one. This did not count as a try.",
      "rewritten": "You scanned your {{class}} instead. We checked that one.",
      "triesLeft": "Tries left: {{n}}",
      "noCountry": "No document can be checked right now. Press \"I can't use a document\" and a person will verify you by video call.",
      "cantUse": "I can't use a document",
      "cantUseText": "We will contact you to verify your identity by video call.",
      "cantUseConfirm": "Continue",
      "cancel": "Cancel",
      "checking": "Checking your document…",
      "slow": "This is taking longer than usual. Come back to this page in a few minutes.",
      "checkAgain": "Check again",
      "slowBackStep": "Back to the document step",
      "nameQuestion": "We read your name as: <name>{{name}}</name> Is this you?",
      "yes": "Yes",
      "notRight": "Not right",
      "notRightThanks": "Thank you. A person will check it.",
      "exempt": "No document needed. Press Continue to finish your registration.",
      "ready": "Your document is checked. Press Continue to finish your registration.",
      "consentChanged": "The company that checks your document has changed. Please read the text again and tick the box.",
      "alreadyVerified": "Your document is already verified. We only need a new face check."
    }
  },
  "tips": {
    "light": "Put the light in front of you, not behind you.",
    "sun": "Avoid direct sun. Go into the shade or indoors. Too much sun also makes the check fail.",
    "cover": "Take off sunglasses, a hat or a face mask.",
    "centre": "Keep your face in the middle of the picture, at the height of your eyes. On a laptop, sit in front of the screen.",
    "screen": "Turn the brightness of your screen up to the highest.",
    "upright": "On a phone, hold it upright, in front of your face.",
    "laptop": "On a computer, the camera should be on top of the screen. Look at the screen.",
    "glasses": "Normal glasses are fine.",
    "still": "Keep your head still until we ask you to move it.",
    "steady": "Hold your phone steady, or put it on a table. On a computer, sit in front of the screen."
  },
  "capture": {
    "look": "Look at the camera",
    "putInOval": "Put your face inside the oval.",
    "stayStill": "Good. Stay still...",
    "done": "Done!",
    "sending": "Sending the pictures...",
    "moveIntro": "During the check we will ask you to move your head a little. It takes about 10 seconds.",
    "moveHint": "Only a little, then stay still. Left means towards your left shoulder, right towards your right shoulder.",
    "noMotion": "We did not see your head move. Move it a little, slowly.",
    "poorQuality": "We could not see your face well. Find more light and try again.",
    "again": "Let's take the pictures again.",
    "noCamera": "We could not open your camera.",
    "noCameraOther": "Maybe another app is using the camera. Close the other apps and try again.",
    "noCameraBlock": "Pressed \"Block\" by mistake?",
    "noCameraHow": "Show me how to allow the camera",
    "videoLabel": "Your camera picture"
  },
  "embedded": {
    "flashTitle": "Before the check",
    "flashText": "The check can use flashing colours on the screen.",
    "flashOk": "I'm OK with flashing lights (untick if they make you unwell, for example epilepsy)",
    "continue": "Continue",
    "loading": "Loading the check...",
    "notWorkTitle": "This check does not work on this phone or computer.",
    "notWorkText": "This did not count as a try. You can:",
    "notWorkSwitch": "do the face check with another company that works for {{org}}, {{other}}. Your name, email and place are kept. You will be asked to agree again for that company.",
    "notWorkUse": "Use {{other}}",
    "notWorkEmail": "or press \"Help\", then \"Email me a link to continue\", and open that email on a newer phone or computer.",
    "notWorkEmailOnly": "You can continue on a newer phone or computer: press \"Help\", then \"Email me a link to continue\", and open that email there.",
    "oneMoment": "Please wait a moment.",
    "finishing": "We are finishing your check with {{provider}}. This can take up to 3 minutes. Please do not close this page.",
    "finishingMail": "(If you close it, we will email you.)"
  },
  "aws": {
    "cameraMinHead": "The camera is not good enough for this check",
    "cameraMinText": "The camera must be able to show at least 320 by 240 points and 15 pictures each second.",
    "cameraNotFoundHead": "We could not open your camera.",
    "cameraNotFoundText": "Check that a camera is connected and that no other app is using it. You may need to allow the camera in the settings of your browser.",
    "videoLabel": "Your camera picture for the face check",
    "cancel": "Cancel the face check",
    "goodFit": "Good",
    "goodFitAlt": "A drawing of a face that fits well inside the oval.",
    "tooFar": "Too far",
    "tooFarAlt": "A drawing of a face inside the oval with a gap around it.",
    "centreFace": "Put your face inside the oval.",
    "centreInstruction": "Before the check starts, make sure your camera is at the top and in the middle of your screen, and put your face in the middle of the picture. An oval will show up. Move forward into the oval, then hold still for a few seconds. You will hear a sound when the check is done.",
    "faceOffCentre": "Put your face inside the oval.",
    "moveInFront": "Put your face inside the oval.",
    "tooMany": "Only one face, please",
    "faceDetected": "Good. Stay still...",
    "cannotIdentify": "Put your face inside the oval.",
    "tooClose": "Move back",
    "moreCloser": "Move closer",
    "connecting": "Connecting...",
    "verifying": "Checking...",
    "complete": "Done!",
    "tooBright": "Too bright",
    "tooDark": "Find more light",
    "lightNormal": "The light is good",
    "hold": "Hold still. The screen will show some colours.",
    "matchIndicator": "Keep moving closer.",
    "photoHead": "Flashing colours",
    "photoBody": "This check flashes different colours on the screen.",
    "photoInfo": "Some people feel unwell when they see flashing colours.",
    "photoLabel": "More about flashing colours",
    "retryCamera": "Try again",
    "rec": "Recording",
    "begin": "Start the face check",
    "waitingPermission": "Waiting for you to allow the camera.",
    "error": "Something went wrong",
    "connTimeoutHead": "The connection took too long",
    "connTimeoutText": "Please try again.",
    "timeoutHead": "The check took too long",
    "timeoutText": "Your face did not fill the oval in time. Please try again and fill the oval with your face.",
    "distanceHead": "You moved forward too early",
    "distanceText": "Do not move closer while the check connects.",
    "multiHead": "More than one face",
    "multiText": "Only one face, please.",
    "clientHead": "The check did not work",
    "clientText": "The check could not run on this phone or computer.",
    "serverHead": "The check did not work",
    "serverText": "We cannot finish the check now. Please try again in a few minutes.",
    "landscapeHead": "Turn your phone upright",
    "landscapeText": "Hold your phone upright.",
    "portraitText": "Keep your phone upright during the whole check.",
    "tryAgain": "Try again"
  },
  "wait": {
    "title": "Checking your face...",
    "text": "Less than a minute. Keep this page open.",
    "thenDocument": "Next: a photo of your identity document.",
    "slow": "This is taking longer than usual. You can close this page. We will email you when it is ready.",
    "returnTitle": "Checking your result"
  },
  "outcome": {
    "tryAgain": "Let's try once more. Find more light and hold still.",
    "tryLeft_one": "You can try {{count}} more time. After that, a person will check your registration by hand.",
    "tryLeft_other": "You can try {{count}} more times. After that, a person will check your registration by hand.",
    "tryNone": "A person will now check your registration by hand.",
    "notStarted": "Something went wrong before the check started. This did not count as a try. Please try again in a few minutes.",
    "duplicateTitle": "We cannot finish this registration.",
    "duplicateText": "We found a voter who looks like you. Each person can join only once.",
    "duplicateJoined": "Did you join before?",
    "duplicateMistake": "A mistake? Write to {{contact}}.",
    "duplicateEmail": "Use the email you used the first time. It may not be the email you wrote today.",
    "genericHint": "The check did not work this time. This often happens with poor light or a blurry picture.",
    "ourSideTitle": "Your check went through, but we could not finish it",
    "ourSideText": "Something went wrong on our side. This try does not count. Please do the face check again.",
    "hint": {
      "LOW_FACE_LUMINANCE": "There was not enough light. Find more light.",
      "LOW_LIGHTING_DETECTED": "There was not enough light. Find more light.",
      "HIGH_FACE_LUMINANCE": "There was too much light. Move away from the sun or a bright window.",
      "HIGH_LIGHTING_DETECTED": "There was too much light. Move away from the sun or a bright window.",
      "EYES_CLOSED_DETECTED": "Keep your eyes open.",
      "HIGH_FACE_OCCLUSION": "Take off anything that covers your face.",
      "FACE_OBSTRUCTION_DETECTED": "Take off anything that covers your face.",
      "FACE_NOT_VISIBLE": "Keep your face inside the oval, facing the screen.",
      "FACE_NOT_ALIGNED": "Keep your face inside the oval, facing the screen.",
      "NO_FACE_DETECTED": "Keep your face inside the oval, facing the screen.",
      "MULTIPLE_FACES_DETECTED": "Only one face, please.",
      "LOW_FACE_QUALITY": "The camera picture was not clear. Clean the camera.",
      "LOW_VIDEO_QUALITY_DETECTED": "The camera picture was not clear. Clean the camera.",
      "RejectedByActiveLiveDetection": "Move your head only a little, and slowly.",
      "MultipleFacesFound": "Only one face, please.",
      "FaceNotFound": "We could not see your face well. Find more light."
    },
    "duplicateSignIn": "Email me a sign-in link"
  },
  "status": {
    "approvedTitle": "Welcome, {{name}}! You are now registered as a voter with {{org}}.",
    "approvedTitleNoName": "Welcome! You are now registered as a voter with {{org}}.",
    "approvedText": "To come back to your voter page, press \"Log in\" and we email you a sign-in link.",
    "reviewTitle": "Thank you, {{name}}. Your registration needs one more look.",
    "reviewTitleNoName": "Thank you. Your registration needs one more look.",
    "reviewNormal": "This is normal. It does not mean you did something wrong.",
    "reviewText": "A person from {{org}} looks at it, usually within 1 to 3 days. We will email you.",
    "why": "Why?",
    "reasonAge": "Your age was not clear.",
    "reasonAgeText": "Our automatic check could not tell your age well. This is common with young people.",
    "reasonPlace": "We want to check your place.",
    "reasonPlaceText": "The place you chose looks far from where your internet connection seems to be, or we could not tell where it is. This can happen with a VPN, a work network or a phone network.",
    "reasonDocument": "We want to check your identity document.",
    "reasonDocumentText": "A person will look at the document check. You do not need to do anything.",
    "reasonFace": "We want to check your face check.",
    "reasonFaceText": "Our automatic check was not sure. This can happen with poor light or a blurry picture.",
    "keeps": "While a person from {{org}} looks at your registration, {{provider}}, the company that did the check, keeps the photos and the video of the check. Only that person can see them. They are deleted when the person decides, at most 30 days from now.",
    "nothingToDo": "You do not need to do anything. If you want to tell us something, use <a>Write to us</a>.",
    "nothingToDoContact": "You do not need to do anything. If you want to tell us something, write to {{contact}}.",
    "needsTitle": "Please do the face check again, {{name}}.",
    "needsTitleNoName": "Please do the face check again.",
    "needsText": "A person from {{org}} looked at your registration and asks you to do the face check one more time. This is not a rejection.",
    "needsButton": "Do the face check again",
    "notAcceptedTitle": "Your registration was not accepted.",
    "notAcceptedText": "A person from {{org}} looked at your registration and could not accept it. Reason: {{reason}}.",
    "notAcceptedHelp": "If you think this is a mistake, write to us at {{contact}} or call or WhatsApp {{phone}}.",
    "notAcceptedHelpNoPhone": "If you think this is a mistake, write to us at {{contact}}.",
    "reasonCat": {
      "age": "your age",
      "place": "your place",
      "face": "the face check",
      "duplicate": "a voter who looks like you already exists",
      "other": "other reasons"
    },
    "deleteButton": "Delete my data"
  },
  "login": {
    "title": "Log in",
    "intro": "Write your email. We send you a link and a 6-digit code to sign in. You need no password.",
    "email": "Email",
    "sendLink": "Email me a sign-in link",
    "usePassword": "Use my password instead",
    "useEmail": "Email me a sign-in link instead",
    "password": "Password",
    "button": "Log in",
    "forgot": "I forgot my password",
    "error": "The email or the password is not right. Please try again.",
    "errEmail": "Please write your email.",
    "errPassword": "Please write your password.",
    "notMember": "Not registered yet?",
    "register": "Register",
    "registrationEnded": "Your registration is finished. To open your voter page, sign in with a link we email you.",
    "checkTitle": "Check your email",
    "checkText": "If <b>{{email}}</b> belongs to a voter, we sent a sign-in link and a 6-digit code. Open the link on any phone or computer, or type the code here, in this browser. Both work for 15 minutes, one time.",
    "passwordNote": "If your account uses a password, sign in with it below.",
    "signIn": "Sign in",
    "resendEmail": "Send a new email",
    "resentEmail": "We sent a new email.",
    "otherEmail": "Use another email",
    "errCodeExpired": "This code is too old. Press \"Send a new email\".",
    "errCodeTooMany": "Too many wrong codes. Press \"Send a new email\" for a new code.",
    "errChallenge": "This code works only in the browser where you asked for it. Open the link in the email instead, or press \"Send a new email\".",
    "codeText": "Your password is right. We sent a 6-digit code to your email. Type it here to sign in.",
    "codeResend": "Send a new code",
    "codeResent": "We sent a new code.",
    "backToPassword": "Write my password again",
    "codeExpired": "This code is too old. Press \"Send a new code\".",
    "codeTooMany": "Too many wrong codes. Press \"Send a new code\".",
    "codeChallenge": "This sign-in has expired. Press \"Write my password again\"."
  },
  "loginLink": {
    "title": "Sign in",
    "text": "Press the button to sign in to your voter page.",
    "button": "Sign in",
    "oldLink": "This link no longer works. It may be older than 15 minutes, already used, or replaced by a newer email.",
    "newEmail": "Send a new email"
  },
  "forgot": {
    "title": "I forgot my password",
    "text": "Write your email. If it belongs to a voter, we send you an email to sign in.",
    "button": "Send me the email",
    "done": "Check your email. If this email belongs to a voter, we sent a sign-in link and a 6-digit code. They work for 15 minutes, one time.",
    "doneReset": "If your account asks for your password and an emailed code, we sent a link to choose a new password instead. It works for 1 hour.",
    "toLogin": "Back to log in"
  },
  "reset": {
    "title": "Choose a new password",
    "button": "Save my new password",
    "done": "Done. Your new password works now. You are signed out on other devices.",
    "oldLink": "This link is too old or was already used. Please ask for a new link.",
    "ask": "Ask for a new link"
  },
  "memberNav": {
    "label": "Your voter pages",
    "openMenu": "Open the menu",
    "account": "Account",
    "overview": "Overview",
    "profile": "My information",
    "contact": "Write to us",
    "signIn": "Sign-in",
    "data": "My data",
    "tabs": {
      "overview": "Overview",
      "profile": "My info",
      "contact": "Write",
      "signIn": "Sign-in",
      "data": "My data"
    },
    "quickTitle": "What would you like to do, {{first}}?",
    "quickTitleNoName": "What would you like to do?",
    "profileHint": "See what you told us.",
    "contactHint": "Send us a message and read our replies.",
    "signInHint": "How you sign in, and your password.",
    "dataHint": "See what we keep, download it or delete it."
  },
  "dashboard": {
    "info": "My information",
    "name": "Name",
    "email": "Email",
    "city": "Place",
    "since": "Voter since",
    "checkedBy": "Face check by",
    "logOut": "Sign out",
    "logOutFailed": "You are not signed out yet. We could not reach the server, so your session is still open. Please try again.",
    "logOutRetry": "Retry",
    "emailSignInNotice": "You can now also sign in with a link sent to your email.",
    "emailSignInNoticeLink": "Sign-in settings",
    "keepsTitle": "What we keep",
    "keeps": {
      "name_and_email": "Your name and your email",
      "city": "The place you chose",
      "consents": "Your agreements (the privacy box and the face check box)",
      "location_evidence": "What we learned about where you are (from your internet connection and your phone or computer)",
      "face_template": "Your face template (not a photo)",
      "face_check_results": "The results of your face check",
      "messages": "Your messages to us and our replies"
    },
    "myData": "My data",
    "download": "Download my data",
    "downloadDone": "Your file was downloaded.",
    "downloadFresh": "Your file holds your face template, so we ask you to sign in again first. We email you a sign-in link and a 6-digit code.",
    "downloadAgain": "You are signed in again. Press \"Download my data\".",
    "deleteLink": "Delete my data",
    "documentWithdraw": {
      "title": "Your identity document",
      "text": "You agreed that we check your identity document. You can withdraw that consent. We then delete the detailed results of the check. The record that your document was checked and your first name stay. If your registration is not decided yet, a person will call you.",
      "button": "Withdraw my document consent",
      "confirmTitle": "Withdraw your document consent?",
      "confirmText": "We delete the detailed results of your document check. This cannot be undone.",
      "confirm": "Withdraw my consent",
      "cancel": "Cancel",
      "done": "Your document consent is withdrawn. The detailed results are deleted."
    }
  },
  "contact": {
    "title": "Write to us",
    "label": "Your message",
    "send": "Send",
    "thread": "Messages",
    "sent": "Thank you. We got your message.",
    "empty": "No messages yet.",
    "you": "You",
    "err": "Please write a message.",
    "left": "You can write {{n}} more letters."
  },
  "changePassword": {
    "title": "Change my password",
    "current": "Your password now",
    "new": "Your new password",
    "button": "Save my new password",
    "done": "Done. Your password was changed. You are signed out on other devices.",
    "errCurrent": "The password now is not right.",
    "errCurrentEmpty": "Please write your password now.",
    "errNew": "Please use at least 8 letters or numbers, and not a password that is easy to guess."
  },
  "signIn": {
    "title": "How you sign in",
    "mode": {
      "email": "You sign in with a link or a 6-digit code that we email you. You have no password.",
      "password_or_email": "You sign in with your password, or with a link or a 6-digit code that we email you.",
      "password_and_email": "You sign in with your password, and then a 6-digit code that we email you."
    },
    "cancel": "Cancel",
    "passwordLabel": "Your password",
    "set": {
      "title": "Set a password",
      "text": "A password is optional. With one you can also sign in with your email and your password.",
      "needFresh": "To set a password, sign in again first. We email you a sign-in link and a 6-digit code.",
      "label": "Your new password",
      "button": "Save my password",
      "done": "Done. Your password is set. You are signed out on other devices.",
      "errFresh": "Your sign-in is more than 10 minutes old. Please sign in again with a link from your email."
    },
    "change": {
      "currentOptional": "You signed in a few minutes ago, so you may leave this empty."
    },
    "code": {
      "title": "A code by email",
      "label": "Also ask for a code sent to my email when I sign in with my password",
      "onText": "On: after your password, we email you a 6-digit code. A sign-in link alone does not work.",
      "offText": "Off: your password alone signs you in. A sign-in link from your email also works.",
      "confirmOff": "To turn this off, write your password.",
      "turnOff": "Turn it off",
      "done": {
        "password_and_email": "Done. We now also ask for a code by email. You are signed out on other devices.",
        "password_or_email": "Done. Your password alone signs you in again. You are signed out on other devices."
      }
    },
    "remove": {
      "title": "Remove my password",
      "text": "You then sign in only with a link or a 6-digit code that we email you.",
      "button": "Remove my password",
      "done": "Done. Your password is removed. You now sign in with the email we send you. You are signed out on other devices."
    },
    "signOut": {
      "title": "Sign out",
      "text": "This signs you out on every phone and computer where you are signed in."
    }
  },
  "freshSignIn": {
    "title": "Sign in again",
    "send": "Email me a sign-in link",
    "sent": "We sent a sign-in link and a 6-digit code to <b>{{email}}</b>. Open the link, or type the code here.",
    "passwordAndCode": "Your account asks for your password and a code by email. Sign out, sign in again with them, then come back to this page.",
    "signOutAndIn": "Sign out and sign in again"
  },
  "deleteData": {
    "title": "Delete your data?",
    "text": "We will delete your name, your email, your place, your messages and your face template at once, and sign you out on every device. You will not be registered as a voter with {{org}} any more. You can register again later.",
    "password": "Your password",
    "button": "Delete my data",
    "doneTitle": "Your data is deleted",
    "done": "Everything is deleted and you are signed out. We asked the company that did the check to delete what it has.",
    "doneNoCheck": "Everything is deleted and you are signed out.",
    "errPassword": "The password is not right.",
    "errPasswordEmpty": "Please write your password.",
    "fresh": "To delete your data, sign in again first. We email you a sign-in link and a 6-digit code.",
    "signedInAgain": "You are signed in again. Press \"Delete my data\".",
    "linkText": "Or we email you a link that deletes your data. It works for 1 hour, one time.",
    "linkButton": "Email me a link to delete my data",
    "linkSent": "We sent you a link to delete your data. It works for 1 hour, one time.",
    "again": "Go to the start"
  },
  "deleteReg": {
    "title": "Delete your registration?",
    "text": "We will delete your name, your email, your place and your face template at once. You can register again later.",
    "button": "Delete my registration",
    "done": "Done. Your registration is deleted. We asked the company that did the check to delete what it has.",
    "doneNoCheck": "Done. Your registration is deleted.",
    "oldLink": "This link is too old or was already used.",
    "again": "Go to the start"
  },
  "erasure": {
    "title": "What the company that did the check still has:",
    "provider_deletes_within_30_days": "We ask {{provider}} today to delete what it has from your check. It must be done within 30 days at the latest. If it is late, we keep asking until it is done, and the people who run {{org}} see it as late.",
    "support_request": "{{provider}} cannot delete single checks for us. We send it a request to delete what it may still keep from checks like yours. {{provider}} decides how long this takes. We keep a note of the request until it answers.",
    "nothing_kept": "{{provider}} does not keep your pictures, so there is nothing for us to ask it to delete.",
    "questions": "Questions about the deletion? Write to us at {{contact}}.",
    "test_provider_cannot_delete": "This was a test with {{provider}}. {{provider}} cannot delete test checks for us. It may keep your test face scan and the extra picture and use them to improve its software. You agreed to this before the test."
  },
  "errors": {
    "rate_limited": "Too many tries. Please wait a few minutes and try again.",
    "network": "We could not reach the server. Check your connection and try again.",
    "device_location_required": "Please share your location first. Go back to step 3.",
    "manual_route": "We will contact you to verify your identity by video call.",
    "document_exemption_stale": "We could no longer confirm that you can skip the document. Please continue from what this page shows now."
  },
  "admin": {
    "common": {
      "cancel": "Cancel",
      "refreshFailed": "Could not refresh just now. Showing what was loaded last; it will try again shortly.",
      "copy": "Copy",
      "copied": "Copied",
      "scrollTable": "Table (scrolls sideways on a small screen)",
      "save": "Save",
      "previous": "Previous",
      "next": "Next",
      "pagination": "Pagination",
      "pageOf": "Page {{page}} of {{pages}} ({{total}} in total)",
      "loadFailed": "The admin pages could not be loaded. Please try again."
    },
    "layout": {
      "title": "Admin",
      "logout": "Log out",
      "forgetDevice": "Forget this device",
      "logoutFailed": "Could not log out. You are still signed in.",
      "forgetFailed": "Could not forget this device. It is still trusted and you are still signed in.",
      "forgetExpired": "Your session has expired, so this device could not be forgotten. It is still trusted. Sign in again, then choose Forget this device.",
      "signInAgain": "Sign in again",
      "navLabel": "Admin pages",
      "openMenu": "Open the menu"
    },
    "nav": {
      "overview": "Overview",
      "members": "Voters",
      "discarded": "Discarded voters",
      "review": "Review queue",
      "map": "Map",
      "groups": "Groups",
      "communications": "Communications",
      "messages": "Messages",
      "providers": "Providers",
      "compare": "Compare providers",
      "blocklist": "Blocklist",
      "admins": "Admins",
      "audit": "Audit log",
      "waiting": "{{count}} waiting",
      "unread_one": "{{count}} new message",
      "unread_other": "{{count}} new messages"
    },
    "login": {
      "title": "Admin sign in",
      "email": "Email",
      "password": "Password",
      "continue": "Continue",
      "codeIntro": "We sent a 6-digit code to your email. Type it here.",
      "trustNote": "We will not ask for a code again on this device for 30 days.",
      "code": "Code",
      "signIn": "Sign in",
      "resend": "Send the code again",
      "resendWait": "You can ask for a new code in {{seconds}} seconds.",
      "resent": "We sent a new code.",
      "errInvalidCode": "This code is not right.",
      "errInvalidCodeLeft_one": "This code is not right. {{count}} try left.",
      "errInvalidCodeLeft_other": "This code is not right. {{count}} tries left.",
      "errAttempts": "Too many wrong codes. Wait 10 minutes and sign in again.",
      "errExpired": "This code has expired. Ask for a new one.",
      "errChallenge": "This sign-in has expired. Start again with your password.",
      "errTooSoon": "Please wait a minute before asking for another code.",
      "errCredentials": "The email or password is not right.",
      "errRate": "Too many tries. Please wait a few minutes.",
      "forgot": "Forgot your password?"
    },
    "forgot": {
      "title": "Forgot your password?",
      "text": "Type the email of your admin account. We will send you a link to choose a new password.",
      "email": "Email",
      "send": "Send me the link",
      "done": "If this email belongs to an admin, we sent a link. It works for 30 minutes.",
      "toLogin": "Back to sign in"
    },
    "reset": {
      "title": "Choose a new password",
      "noToken": "This link is incomplete. Open the link from the email again.",
      "password": "New password",
      "again": "Type the password again",
      "errShort": "Use at least {{min}} characters.",
      "mismatch": "The two passwords are different.",
      "save": "Save my new password",
      "invalid": "This link is too old or was already used. Please ask for a new link.",
      "ask": "Ask for a new link",
      "doneTitle": "Password changed",
      "done": "Your new password works now. You were signed out everywhere. Sign in with your email, the new password and the code we email you.",
      "toLogin": "Go to sign in"
    },
    "invite": {
      "title": "Accept your invitation",
      "noToken": "This link is incomplete. Open the link from the invitation email.",
      "name": "Your name",
      "password": "Password",
      "passwordHelp": "At least {{min}} characters. Do not use a common password.",
      "again": "Type the password again",
      "mismatch": "The two passwords are different.",
      "accept": "Create my account",
      "invalid": "This invitation link is not valid any more. Ask for a new invitation.",
      "doneTitle": "Account created",
      "done": "Your account is ready. Sign in with your email, password and the code we email you.",
      "toLogin": "Go to sign in"
    },
    "overview": {
      "title": "Overview",
      "needAttention_one": "{{count}} provider deletion needs attention",
      "needAttention_other": "{{count}} provider deletions need attention",
      "providers": "Providers",
      "active": "Active",
      "inactive": "Not active",
      "healthy": "Healthy",
      "unhealthy": "Problem",
      "notConfigured": "Not configured",
      "noneActive": "No face-check provider is switched on.",
      "idleProviders_one": "{{count}} provider not in use: {{names}}",
      "idleProviders_other": "{{count}} providers not in use: {{names}}",
      "credit": "Credit: {{value}}",
      "quota": "Quota: {{value}}",
      "balance": "Balance: {{value}}",
      "month": "{{attempts}} attempts this month",
      "estimated": "about {{value}}",
      "costUnknown": "cost unknown",
      "byProvider": "Voters by provider",
      "perDay": "Registrations per day (last 30 days)",
      "perDayShort": "Registrations",
      "perDayHeadline_one": "{{count}} in the last 30 days. Busiest day: {{day}}, with {{peak}}.",
      "perDayHeadline_other": "{{count}} in the last 30 days. Busiest day: {{day}}, with {{peak}}.",
      "perDayAria": "Bar chart of registrations per day over the last 30 days: {{count}} in total, busiest day {{day}} with {{peak}}",
      "perDayBar": "{{day}}: {{count}} registrations",
      "perDayHelp": "How many people started registering each day.",
      "decisionsTitle": "Decisions per day (last 30 days)",
      "decisionsHelp": "Each column is one day: accepted registrations in green, registrations that were not accepted in red.",
      "decisionsApproved": "Accepted",
      "decisionsRejected": "Not accepted",
      "decisionsAria": "Bar chart of decisions per day over the last 30 days: {{approved}} accepted and {{rejected}} not accepted, busiest day {{day}} with {{peak}}",
      "decisionsBar": "{{day}}: {{count}} {{kind}}",
      "noDecisions": "No decisions in the last 30 days.",
      "unreadTitle_one": "{{count}} new message",
      "unreadTitle_other": "{{count}} new messages",
      "unreadHint": "Voters are waiting for an answer. Open the inbox to read and reply.",
      "cardReview": "Waiting for review",
      "hintReview": "A person needs to look at these",
      "cardMessages": "New messages",
      "hintMessages": "Voters are waiting for an answer",
      "hintNoMessages": "Nothing new since you last looked",
      "cardWeek": "New registrations, last 7 days",
      "hintWeek_one": "{{count}} in the 7 days before",
      "hintWeek_other": "{{count}} in the 7 days before",
      "cardAccepted": "Accepted, last 30 days",
      "hintAccepted_one": "{{approved}} of {{count}} decision",
      "hintAccepted_other": "{{approved}} of {{count}} decisions",
      "hintNoDecisions": "No decisions yet",
      "recentTitle": "Recent activity",
      "recentEmpty": "Nothing has happened yet.",
      "recentFailed": "Recent activity could not be loaded.",
      "recentSystem": "The system",
      "recentAll": "See the full activity log",
      "standTitle": "Where registrations stand",
      "standHelp_one": "{{count}} registration so far, by where it is now. A number opens the list.",
      "standHelp_other": "{{count}} registrations so far, by where each one is now. A number opens the list.",
      "standEmpty": "Nobody has registered yet.",
      "noRegistrations": "No registrations yet.",
      "supportActions": "Provider deletions by support request",
      "noActions": "Nothing to follow up.",
      "supportErasure": "Support erasure at {{provider}}",
      "overdue": "Overdue",
      "paOpened": "Opened {{date}}",
      "paRequested": "requested {{date}}",
      "paClosed": "closed {{date}}",
      "paRefs": "{{count}} references",
      "paNote": "Note (optional)",
      "pa_open": "Open",
      "pa_requested": "Requested",
      "pa_confirmed": "Confirmed",
      "pa_unresolved": "Unresolved",
      "pa_mark_requested": "Mark requested",
      "pa_mark_confirmed": "Mark confirmed",
      "pa_mark_unresolved": "Mark unresolved",
      "od_ref_stuck": "{{provider}}: a deletion is stuck.",
      "od_ref_late": "{{provider}}: a deletion is late (due {{date}}).",
      "od_action_stuck": "{{provider}}: a support request is stuck.",
      "od_action_late": "{{provider}}: a support request is late (due {{date}}).",
      "totalOf_one": "{{count}} voter",
      "totalOf_other": "{{count}} voters"
    },
    "charts": {
      "viewData": "View data",
      "day": "Day",
      "daysLeftOut": "Days not listed had none."
    },
    "members": {
      "title": "Voters",
      "view": "Show",
      "viewMembers": "Voters",
      "viewInProgress": "In progress",
      "viewInProgressCount": "In progress ({{count}})",
      "search": "Search",
      "searchHint": "Name, email or city",
      "filterStatus": "Status",
      "filterProvider": "Provider",
      "filterGroup": "Group",
      "any": "Any",
      "onlyDivergence": "Only IP far from the declared city",
      "empty": "No voters match.",
      "noName": "(no name)",
      "select": "Select {{name}}",
      "selectAll": "Select all on this page",
      "selected_one": "{{count}} voter selected",
      "selected_other": "{{count}} voters selected",
      "selectedOnPage_one": "{{count}} on this page",
      "selectedOnPage_other": "{{count}} on this page",
      "bulk": "Bulk actions",
      "pickGroup": "Choose a group",
      "addToGroup": "Add to group",
      "clear": "Clear selection",
      "added_one": "{{count}} voter added.",
      "added_other": "{{count}} voters added.",
      "removeFromGroup": "Remove from group",
      "removed_one": "{{count}} voter removed.",
      "removed_other": "{{count}} voters removed.",
      "colName": "Name",
      "colEmail": "Email",
      "colCity": "City",
      "colProvider": "Provider",
      "colStatus": "Status",
      "colReasons": "Reasons",
      "colDivergence": "IP distance",
      "colRegistered": "Registered",
      "filters": "Filters",
      "filtersActive_one": "{{count}} filter on",
      "filtersActive_other": "{{count}} filters on",
      "clearFilters": "Clear filters",
      "more": "More",
      "showDiscarded": "Show discarded voters →"
    },
    "discarded": {
      "title": "Discarded voters",
      "intro": "Duplicates and registrations an admin did not accept. They are left out of the Voters list.",
      "filterReason": "Reason",
      "reason_duplicate": "Duplicate",
      "reason_not_accepted": "Not accepted",
      "empty": "No discarded voters match.",
      "colWhy": "Why",
      "matches": "Same face as",
      "matchGone": "the matched voter was erased",
      "rejectReason": "Reason: {{reason}}",
      "backToMembers": "← Back to voters",
      "rowActions": "Actions for {{name}}",
      "colActions": "Actions"
    },
    "bulk": {
      "actionsLabel": "Change the selected voters",
      "tooMany": "At most {{max}} voters at a time. Clear part of the selection to use these actions.",
      "whoLabel": "Selected voters",
      "andMore_one": "and {{count}} more",
      "andMore_other": "and {{count}} more",
      "approveTitle_one": "Approve {{count}} voter?",
      "approveTitle_other": "Approve {{count}} voters?",
      "approveBody": "Each voter in review is approved and told by email. Voters in another state are skipped, and so is a voter whose face is close to another voter (approve that one from its page).",
      "rejectTitle_one": "Reject {{count}} voter?",
      "rejectTitle_other": "Reject {{count}} voters?",
      "rejectBody": "Each voter in review or approved is told by email that the registration was not accepted. Voters in another state are skipped.",
      "newFaceCheckTitle_one": "Ask {{count}} voter for a new face check?",
      "newFaceCheckTitle_other": "Ask {{count}} voters for a new face check?",
      "newFaceCheckBody": "Each voter in review or rejected gets another face check and an email. Voters in another state are skipped.",
      "unblockTitle_one": "Unblock {{count}} voter?",
      "unblockTitle_other": "Unblock {{count}} voters?",
      "unblockBody": "Each blocked duplicate is erased and can register again; the next decision for that email goes to review. Voters in another state are skipped.",
      "eraseTitle_one": "Erase {{count}} voter?",
      "eraseTitle_other": "Erase {{count}} voters?",
      "eraseBody_one": "All data of {{count}} voter is deleted, the face template too, and the provider is asked to delete its copy. This cannot be undone.",
      "eraseBody_other": "All data of {{count}} voters is deleted, their face templates too, and the providers are asked to delete their copies. This cannot be undone.",
      "eraseType": "Type {{count}} or ERASE to confirm",
      "applied_approve": "Approved {{count}}",
      "applied_reject": "Rejected {{count}}",
      "applied_newFaceCheck": "Asked {{count}} for a new face check",
      "applied_unblock": "Unblocked {{count}}",
      "applied_erase": "Erased {{count}}",
      "skippedCount": ", skipped {{count}}",
      "skippedTitle": "Skipped",
      "skippedItem": "{{name}}: {{reason}}",
      "dismiss": "Dismiss",
      "skip_invalid_state_transition_approve": "not in review",
      "skip_invalid_state_transition_reject": "not in review or approved",
      "skip_invalid_state_transition_newFaceCheck": "not in review or rejected",
      "skip_invalid_state_transition_unblock": "not a blocked duplicate",
      "skip_invalid_state_transition_erase": "already erased",
      "skip_approval_needs_recapture": "needs a new face check (no usable face template)",
      "skip_uniqueness_conflict": "the face matches another voter",
      "skip_needs_confirmation": "the face is close to another voter: approve it from the voter page",
      "skip_not_found": "no longer exists",
      "skip_matcher_unavailable": "the face index was busy: try again in a few minutes",
      "skip_approval_needs_manual_verification": "a document or face result needs a manual check (video call)",
      "skip_needs_document_confirmation": "a person must review the document",
      "skip_manual_route": "no first face check to compare with (use the video call from the voter page)",
      "skip_document_manual_only": "cannot pass the document step again (use the video call from the voter page)",
      "skippedGroup_one": "{{count}} skipped: {{reason}}",
      "skippedGroup_other": "{{count}} skipped: {{reason}}",
      "skip_other": "could not be changed"
    },
    "review": {
      "title": "Review queue",
      "empty": "Nobody is waiting for a review.",
      "waitingSince": "Waiting since"
    },
    "detail": {
      "noEmail": "(no email)",
      "rejectReason": "Reason: {{reason}}",
      "backToQueue": "Back to the queue",
      "queuePos": "{{n}} of {{total}} in the queue",
      "nextInQueue": "Next in the queue",
      "recordSummary": "Record and timestamps",
      "faceCheck": "Face check",
      "location": "Location",
      "images": "Provider images",
      "record": "Record",
      "messages": "Messages",
      "provider": "Provider",
      "providerDecision": "Provider decision",
      "liveness": "Liveness",
      "noScore": "provider gives no score",
      "warnings": "Provider notes",
      "noWarnings": "None",
      "none": "None",
      "age": "Age",
      "ageUnknown": "Age not available",
      "ageYears": "{{years}} years ({{source}})",
      "ageSource_provider": "provider estimate",
      "ageSource_own": "our own estimate",
      "ageBand": "Age band: {{band}}",
      "ageOwn": "Our own age model: {{years}}",
      "uniqueness": "Uniqueness",
      "band_unique": "Unique",
      "band_borderline": "Close to another voter",
      "band_duplicate": "Duplicate",
      "similarity": "Similarity {{value}}",
      "matchedMember": "Matched voter: {{name}}",
      "secondCandidate": "Second candidate: {{name}}",
      "attempts": "Attempts",
      "attemptsOf": "{{used}} of {{allowed}} used",
      "noTemplate": "No usable face template is stored: use New face check.",
      "attemptWhen": "When",
      "attemptStatus": "Attempt",
      "attemptOutcome": "Outcome",
      "notCounted": "(not counted)",
      "declaredCity": "Declared city",
      "confidence": "{{value}}% sure",
      "noCity": "No declared city yet.",
      "noCoordinates": "No coordinates available.",
      "source": "IP source",
      "sourceAnswer": "Answer",
      "sourceFailed": "No answer",
      "distance": "Distance",
      "network": "Network",
      "flags": "Flags",
      "gps": "GPS readings",
      "observations": "IP observations",
      "mediaNone": "No images available for this provider",
      "mediaNotInReview": "Images can be shown only while the voter is in review.",
      "mediaNoAttempt": "There is no attempt to show images for.",
      "mediaShow": "Show provider images",
      "mediaNext": "Next image",
      "mediaEnd": "No more images.",
      "mediaAlt": "Provider image {{n}}",
      "stage": "Stage",
      "registered": "Registered",
      "emailVerified": "Email verified",
      "locationSet": "Location set",
      "faceStarted": "Face check started",
      "decided": "Decided",
      "erased": "Erased",
      "consentPrivacy": "Privacy consent",
      "consentBiometric": "Face-check consent",
      "extraAttempts": "Extra attempts",
      "signIn": "Sign-in",
      "signInMode": {
        "email": "Email link or code",
        "password_or_email": "Password, or email link or code",
        "password_and_email": "Password and email code"
      },
      "groups": "Groups"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "newFaceCheck": "New face check",
      "unblock": "Unblock",
      "erase": "Erase",
      "approveTitle": "Approve this voter?",
      "approveBody": "The voter is approved and told by email.",
      "approveTick": "I checked the possible match",
      "approveDocumentTick": "I reviewed the document result",
      "approveExemptionTick": "I reviewed the exemption",
      "rejectTitle": "Reject this voter?",
      "rejectBody": "The voter is told by email that the registration was not accepted.",
      "rejectReason": "Reason",
      "reason_age": "Age",
      "reason_place": "Place",
      "reason_face": "Face",
      "reason_other": "Other",
      "alsoBlock": "Also block this email",
      "newFaceCheckTitle": "Ask for a new face check?",
      "newFaceCheckBody": "The voter gets another face check. The earlier template is removed.",
      "unblockTitle": "Unblock this voter?",
      "unblockBody": "The voter can try again. Their next decision goes to review.",
      "eraseTitle": "Erase this voter?",
      "eraseBody": "All data of this voter is deleted. This cannot be undone.",
      "more": "More",
      "verifyManually": "Verified manually",
      "verifyByVideoCall": "Verify by video call",
      "newFaceCheckNoDocument": "No new document is needed.",
      "newFaceCheckReuse": "The document already scanned is used again.",
      "documentsRestrictedTitle": "Turn on documents for {{country}}?",
      "documentsRestrictedBody": "This country starts turned off: {{reason}}. Turn it on only when that has been cleared.",
      "documentsRestrictedTick": "I checked this and want documents processed",
      "documentsRestrictedConfirm": "Turn on"
    },
    "map": {
      "title": "Voters map",
      "empty": "No voters with a declared city yet.",
      "legend": "Map legend"
    },
    "groups": {
      "title": "Groups",
      "newName": "New group name",
      "create": "Create group",
      "empty": "No groups yet.",
      "name": "Name",
      "members": "Voters",
      "created": "Created",
      "rename": "Rename",
      "delete": "Delete",
      "renameNamed": "Rename {{name}}",
      "deleteNamed": "Delete {{name}}",
      "deleteTitle": "Delete the group {{name}}?",
      "deleteBody": "The voters stay; only the group is removed.",
      "cardMeta_one": "{{count}} voter, created",
      "cardMeta_other": "{{count}} voters, created"
    },
    "comms": {
      "title": "Communications",
      "compose": "New message",
      "history": "History",
      "subject": "Subject",
      "body": "Message",
      "bodyHelp": "Plain text. Every message has an unsubscribe link.",
      "audience": "Audience",
      "allApproved": "All approved voters",
      "pickGroups": "Choose at least one group.",
      "recipients_one": "{{count}} recipient",
      "recipients_other": "{{count}} recipients",
      "sendTest": "Send a test to me",
      "send": "Send",
      "testSent": "The test was sent to your email.",
      "confirmTitle": "Send this message?",
      "confirmBody_one": "\"{{subject}}\" will be sent to {{count}} voter.",
      "confirmBody_other": "\"{{subject}}\" will be sent to {{count}} voters.",
      "noHistory": "Nothing sent yet.",
      "status": "Status",
      "counts": "Delivery",
      "countsText": "{{sent}} sent, {{pending}} waiting, {{failed}} failed, {{skipped}} skipped (of {{total}})",
      "created": "Created",
      "details": "Recipients",
      "hide": "Hide",
      "detailsNamed": "Recipients of {{subject}}",
      "hideNamed": "Hide the recipients of {{subject}}",
      "recipientsTitle": "Recipients",
      "sentAt": "Sent",
      "error": "Error",
      "cs_queued": "Queued",
      "cs_sending": "Sending",
      "cs_sent": "Sent",
      "cs_failed": "Failed",
      "rs_pending": "Waiting",
      "rs_sent": "Sent",
      "rs_failed": "Failed",
      "rs_skipped": "Skipped",
      "needContent": "Add a subject and a message to send.",
      "noRecipients": "Nobody is in this audience yet.",
      "previewFailed": "The recipient count could not be loaded, so nothing can be sent yet.",
      "previewPending": "Counting the recipients of this audience."
    },
    "messages": {
      "title": "Messages",
      "empty": "No messages.",
      "none": "No messages yet.",
      "thread": "Conversation",
      "openMember": "Open the voter",
      "fromAdmin": "Admin",
      "fromMember": "Voter",
      "replyLabel": "Reply",
      "send": "Send reply",
      "unread_one": "{{count}} unread",
      "unread_other": "{{count}} unread",
      "back": "Back to inbox"
    },
    "admins": {
      "title": "Admins",
      "invite": "Invite an admin",
      "email": "Email address",
      "sendInvite": "Send invitation",
      "invited": "Invitation sent to {{email}}.",
      "accounts": "Accounts",
      "status_active": "Active",
      "status_revoked": "Revoked",
      "revoke": "Revoke",
      "revokeNamed": "Revoke {{email}}",
      "revokeInviteNamed": "Revoke the invitation for {{email}}",
      "openInvites": "Open invitations",
      "noInvites": "No open invitations.",
      "expires": "Expires {{date}}",
      "revokeInvite": "Revoke invitation",
      "revokeTitle": "Revoke {{email}}?",
      "revokeBody": "This admin is signed out and cannot sign in again.",
      "revokeInviteTitle": "Revoke the invitation for {{email}}?",
      "revokeInviteBody": "The invitation link stops working.",
      "devices": "Your trusted devices",
      "devicesIntro": "These browsers skip the sign-in code until the date shown. The password is always needed.",
      "devicesLogoutHint": "Logging out keeps a device trusted. Use Revoke all if a device may be lost or stolen.",
      "noDevices": "No trusted devices.",
      "device": "Device",
      "thisDevice": "This device",
      "deviceAdded": "Added",
      "deviceLastUsed": "Last used",
      "deviceExpires": "Expires",
      "revokeDevice": "Revoke {{label}}",
      "revokeAllDevices": "Revoke all",
      "name": "Name",
      "status": "Status",
      "added": "Added",
      "expiresOn": "Expires"
    },
    "blocklist": {
      "title": "Blocklist",
      "intro": "Blocked registrations are kept as hashes only. No email address is stored here.",
      "empty": "Nothing is blocked.",
      "reason": "Reason",
      "reason_duplicate": "Duplicate face",
      "reason_admin": "Blocked by an admin",
      "blockedOn": "Blocked on",
      "registration": "Registration",
      "openMember": "Open voter",
      "erased": "Registration erased",
      "showUnblocked": "Also show unblocked entries",
      "noActive": "No active entries. Tick the box above to see the unblocked ones.",
      "unblockEntry": "Unblock entry from {{date}}",
      "openMemberEntry": "Open voter (entry from {{date}})",
      "matchedEntry": "{{name}} (matched voter, entry from {{date}})",
      "matched": "Matched voter",
      "unblockedOn": "Unblocked on",
      "unblock": "Unblock",
      "unblockNamed": "Unblock the entry of {{when}}",
      "unblockTitle": "Unblock this entry?",
      "unblockBody": "The person can register again."
    },
    "audit": {
      "title": "Audit log",
      "filter": "Filter by action",
      "empty": "No entries.",
      "when": "When",
      "admin": "Admin",
      "action": "Action",
      "target": "Target",
      "details": "Details",
      "member": "Voter"
    },
    "providers": {
      "title": "Providers",
      "default": "Default",
      "effective": "Effective",
      "notEffective": "Not effective",
      "notApproved": "not approved for this deployment",
      "notConfigured": "Not configured",
      "enabled": "Enabled",
      "makeDefault": "Make default",
      "joinLink": "Registration link",
      "copyLink": "Copy the link of {{id}}",
      "qrTitle": "QR code for {{link}}",
      "qrDownload": "Download QR as PNG",
      "checkHealth": "Check health and credits",
      "runSetup": "Run setup",
      "settings": "Settings",
      "saveSettings": "Save settings",
      "livenessPassLine": "Liveness pass line",
      "livenessPassLineHelp": "A score at or above this passes. Below it the attempt goes to review or fails.",
      "ageSource": "Age taken from",
      "ageSourceProvider": "The provider",
      "ageSourceOwn": "Our own age model",
      "agePassLine": "Age pass line (years)",
      "agePassLineHelp": "An estimate at or above this passes the age check.",
      "price": "Price per attempt (USD)",
      "priceHelp": "Leave empty when unknown. Used for cost estimates only.",
      "diditMethod": "Liveness method",
      "diditMethodHelp": "Passive is the default. Active 3D asks for a head movement and works on phones.",
      "diditPassive": "Passive",
      "diditActive": "Active 3D",
      "awsChallenge": "Challenge",
      "awsChallengeHelp": "Movement and light is the stronger check.",
      "awsLight": "Face movement and light",
      "awsMovement": "Face movement only",
      "awsFailScore": "Fail score",
      "awsFailScoreHelp": "Below this score the attempt fails. Between this and the pass line it goes to review.",
      "awsAgeRange": "Record the AWS age range",
      "awsAgeRangeHelp": "Recorded for comparison only. Our own age model decides.",
      "awsRecent": "Recent phones and computers only",
      "awsRecentHelp": "The welcome page then says the check needs a recent device.",
      "ipSources": "IP sources",
      "source": "Source",
      "sourceKind": "Kind",
      "sourceStatus": "Status",
      "lastRefresh": "Last refresh",
      "enableSource": "Enable {{id}}",
      "geo": "location",
      "risk": "risk",
      "offline": "offline",
      "testIp": "Test an IP",
      "testIpLabel": "IP address",
      "testIpRun": "Test",
      "testIpNone": "No source answered.",
      "testIpOk": "Answered",
      "testIpFailed": "Failed",
      "testIpPlaceSearch": "Search a place to test against",
      "testIpPlace": "Place to test against",
      "testIpNoPlace": "No place (sources only)",
      "testIpNotAvailable": "Not available",
      "testIpCloudflare": "Not available for a typed IP: Cloudflare answers only for a real visit.",
      "testIpAgainst": "The IP alone against {{place}}:",
      "testIpNetwork": "Network: {{network}}",
      "testIpDistance": "{{km}} km from the place",
      "testIpNoReason": "No location reason from the IP alone.",
      "details": "Link, health and settings",
      "qrShow": "Show the QR code"
    },
    "location": {
      "title": "Location policy",
      "intro": "How the location of a registration is checked. A person always decides when the location is not clear; location never rejects on its own.",
      "level": "Required match",
      "level_area": "Area around the place",
      "level_region": "Region",
      "level_country": "Country",
      "levelHelp_area": "Within the radius of the declared place. Only the device location can prove it.",
      "levelHelp_region": "In the declared region (province, state). Only the device location can prove it; IP sources prove the country at most.",
      "levelHelp_country": "In the declared country. The device location proves it; an IP in the country supports it.",
      "radius": "Radius",
      "radiusTown": "Town (10 km)",
      "radiusArea": "Area (25 km)",
      "radiusWide": "Wide area (50 km)",
      "radiusCustom": "Custom",
      "radiusKm": "Radius (km, 5 to 200)",
      "minAccuracy": "Least precise device location that counts (m)",
      "minAccuracyHelp": "A less precise location goes to a person. With these values a location counts up to {{km}} km from the place.",
      "device": "Device location",
      "device_required": "Required (a person checks if it cannot be shared)",
      "device_strict": "Strict (cannot register without it)",
      "device_optional": "Optional",
      "deviceHelp_required": "No automatic approval without the device location. People who cannot share it can still continue; a person checks them.",
      "deviceHelp_strict": "Step 3 cannot continue without the device location.",
      "deviceHelp_optional": "Without the device location, an IP in the declared country (not a mobile network, no VPN) is enough.",
      "strictWarning": "People whose device cannot share its location will not be able to register.",
      "vpn": "VPN, proxy, Tor or datacenter IP",
      "vpn_review": "A person checks it",
      "vpn_ignore": "Ignore",
      "vpnHelp": "Such an IP says nothing about where the person is.",
      "timezone": "Compare the device timezone with the place",
      "timezoneHelp": "A weak signal: a different timezone sends to a person only when the device location does not match.",
      "newOnly": "A change applies to registrations checked from now on; earlier decisions keep the policy they were checked with.",
      "saved": "Location policy saved.",
      "verdict": {
        "match": "Match",
        "mismatch": "Mismatch",
        "inconclusive": "Inconclusive",
        "missing": "Missing",
        "unknown": "Unknown",
        "flagged": "VPN / proxy"
      },
      "pass": "Location passed",
      "review": "Location needs a look",
      "rowSource": "Evidence",
      "rowVerdict": "Verdict",
      "rowWhy": "Why",
      "rowDevice": "Device location",
      "rowIpCountry": "IP country",
      "rowTimezone": "Timezone",
      "diag": "First fix {{first}}, best {{best}}, after {{elapsed}}, age {{age}}, {{ua}}",
      "stale": "too old",
      "samples": "Samples",
      "suspect": "Possible fake location (not a reason)",
      "policyAt": "Policy used on {{at}}",
      "deviceAnswer": "Device location answer",
      "refusedAt": "Could not share ({{reason}}), {{at}}",
      "supports": "supports",
      "prior": "from the previous decision (the device location is no longer kept)"
    },
    "documents": {
      "title": "Identity document",
      "intro": "Whether voters must show an identity document when they register. While it is on, every document check goes to a person. A change applies to new registrations only.",
      "require": "Require an identity document",
      "requireHelp": "Off by default. While it is on, every document check goes to a person.",
      "requireUnavailable": "Not available: {{providers}}",
      "providersTitle": "Providers",
      "defaultProvider": "Default provider",
      "defaultProviderHelp": "Used for every country without its own provider.",
      "coverage_one": "Covers {{count}} country",
      "coverage_other": "Covers {{count}} countries",
      "fixedList": "Fixed country list",
      "listFetched": "Country list fetched {{date}}",
      "listNever": "Country list not fetched yet",
      "refresh": "Refresh country list",
      "refreshLabel": "Refresh country list ({{name}})",
      "refreshed": "Country list updated.",
      "countriesTitle": "Countries",
      "countriesHelp": "Documents are processed for every country unless it is turned off. The provider and the exemption apply to countries that are on.",
      "search": "Search countries",
      "noMatch": "No country matches.",
      "enableAll": "Enable all countries",
      "disableAll": "Disable all countries",
      "viewLabel": "Which countries to list",
      "viewExceptions": "Exceptions ({{count}})",
      "viewAll": "All countries ({{count}})",
      "scopeExceptions": "Exceptions: the countries that are off, use their own provider or have an exemption. Search to find any other country.",
      "scopeAll_one": "All {{count}} country, in pages of 20.",
      "scopeAll_other": "All {{count}} countries, in pages of 20.",
      "scopeSearch_one": "{{count}} of {{total}} countries matches the search.",
      "scopeSearch_other": "{{count}} of {{total}} countries match the search.",
      "noExceptions": "No exceptions: every country is on, with the default provider and no exemption.",
      "bulkSkipped": "Left on because they have their own provider or an exemption (remove that first): {{countries}}",
      "noProviders": "No identity-document provider is set up on this deployment yet.",
      "colCountry": "Country",
      "colProcessing": "Processing",
      "colProvider": "Provider",
      "colExemption": "Exemption",
      "processingLabel": "Process documents from {{country}}",
      "providerLabel": "Provider for {{country}}",
      "exemptionLabel": "Exemption for {{country}}",
      "on": "On",
      "off": "Off",
      "offWith": "Off: {{reason}}",
      "useDefault": "Default ({{name}})",
      "noCoverage": "{{name}} (does not cover this country)",
      "exemptNone": "No exemption",
      "exemptHelp": "A voter in an exempt country skips the document only when the device location, the IP country and the time zone all match at this level. A person still reviews the registration.",
      "exempt_area": "Exempt at area level",
      "exempt_region": "Exempt at region level",
      "exempt_country": "Exempt at country level",
      "restrictedTitle": "Off by default",
      "restrictedHelp": "These countries start turned off for legal reasons:",
      "classesTitle": "Document types",
      "classesHelp": "The same for every country. Residence permits and cards that are not identity documents are not accepted.",
      "assuranceTitle": "Automatic approval",
      "assuranceEmpty": "No automatic approval: every document check goes to a person.",
      "assuranceRow": "{{class}} · {{issuer}} · {{provider}} · face check {{liveness}}",
      "holdTitle": "Photos for reviews",
      "holdLabel": "Photos for reviews kept at most (days)",
      "holdHelp": "When a registration goes to a person, the photos of the face check and of the document are kept for the review. They are deleted at the decision, and at the latest this many days after the registration entered review. Between {{min}} and {{max}} days. Database backups keep deleted photos for up to 30 more days.",
      "holdInvalid": "Enter a whole number of days between {{min}} and {{max}}.",
      "save": "Save document policy",
      "saving": "Saving",
      "discard": "Discard changes",
      "unsaved": "You have unsaved changes.",
      "saved": "Document policy saved.",
      "conflict": "Someone else changed the document policy. The latest version is loaded. Please make your change again.",
      "loadFailed": "The document policy could not be loaded."
    },
    "compare": {
      "title": "Compare providers",
      "periodLabel": "Period",
      "lastDays": "Last {{days}} days",
      "custom": "Custom range",
      "maxRange": "Up to 366 days.",
      "period": "Showing {{from}} to {{to}}.",
      "noDecisions": "No decisions yet",
      "rateOf_one": "approved: {{approved}} of {{count}} decided registration",
      "rateOf_other": "approved: {{approved}} of {{count}} decided registrations",
      "endedAria": "How the registrations with {{name}} ended: {{parts}}",
      "barKey": "The bar on each card shows how registrations ended:",
      "approvalRate": "Approval rate",
      "statStarted": "Started",
      "statDecided": "Decided",
      "statApproved": "Approved",
      "statWaiting": "Waiting for a person",
      "statRejected": "Rejected or blocked",
      "statScore": "Gave a face score",
      "statTime": "Typical face step",
      "statCost": "Estimated cost",
      "chartOutcomes": "How registrations ended",
      "chartScores": "Face-check scores",
      "scoreBand": "Score band",
      "chartScoresHelp": "How many face checks fell in each score band, from 0 (lowest) to 100 (highest). The charts share one scale.",
      "chartNoData": "Nothing to chart in this period.",
      "chartTrend": "New registrations per day",
      "chartTrendHelp": "How many people started registering each day, one line per provider. Use it to see whether a provider is getting busier or quieter.",
      "chartTrendHelpOne": "How many people started registering each day. Use it to see whether things are getting busier or quieter.",
      "trendStartedWord": "started",
      "trendPoint": "{{name}}, {{day}}: {{count}} started",
      "tableTitle": "Side by side",
      "colProvider": "Provider",
      "sortBy": "Sort by {{column}}",
      "sortLabel": "Sort by",
      "sortAscending": "Order: ascending",
      "sortDescending": "Order: descending",
      "detailsTitle": "Technical details: funnel, methods, codes and prices",
      "from": "From",
      "to": "To (included)",
      "csv": "Download comparison (CSV)",
      "calibrationCsv": "Download calibration (CSV)",
      "note": "Totals only. No voter is named here or in the CSV files.",
      "empty": "No data in this period.",
      "noneActive": "No provider had any registrations in this period.",
      "noneActiveHelp": "Choose a longer period, or check back once voters have registered.",
      "singleTitle": "Only {{name}} had registrations in this period",
      "singleHelp": "There is no other provider to compare it with yet, so this page shows its own figures.",
      "idle_one": "No activity in this period: {{names}}.",
      "idle_other": "{{count}} providers with no activity in this period: {{names}}.",
      "testProvider": "Test (staff only), not voters",
      "assurance": "Assurance",
      "started": "Started",
      "emailVerified": "Email verified (lost)",
      "locationSet": "Location set (lost)",
      "faceStarted": "Face check started (lost)",
      "decided": "Decided (lost)",
      "medianFace": "Median face step",
      "decidedAttempts": "Decided attempts",
      "numericShare": "Attempts with a numeric score",
      "histogram": "Score histogram (0-9 ... 90-100)",
      "methods": "Liveness methods",
      "outcomeCodes": "Outcome codes",
      "reviewReasons": "Review reasons",
      "ageGap": "Age gap (own minus provider)",
      "ageGapText": "{{n}} attempts, mean {{mean}}, median {{median}} years",
      "price": "Price per attempt",
      "attempts": "Attempts that reached the provider",
      "cost": "Estimated cost",
      "unknown": "unknown",
      "retries": "Retries per voter",
      "moreFigures": "More figures: scores, methods, cost"
    },
    "reviewMedia": {
      "title": "Photos for the review",
      "deletedBy": "Deleted at the decision, at the latest on {{date}}.",
      "audited": "Every photo you open is recorded in the audit log. The watermark discourages copies; it does not prevent them. Do not save or share the photos.",
      "show": "Show the photos",
      "hide": "Hide the photos",
      "loading": "Loading the photo…",
      "failed": "This photo could not be shown. It may have been deleted.",
      "enlarge": "Enlarge: {{kind}}",
      "alt": "{{kind}} photo",
      "close": "Close",
      "watermark": "{{email}} · {{at}}",
      "kind_live_face": "Face check",
      "kind_doc_portrait": "Document portrait",
      "kind_doc_front": "Document front",
      "kind_doc_back": "Document back"
    },
    "docPanel": {
      "title": "Identity document",
      "required": "Required for this voter",
      "requiredYes": "Yes: the voter has no first decision yet",
      "requiredNo": "No",
      "none": "No document result on record.",
      "source": "Shown from",
      "source_decision": "The first decision",
      "source_evidence": "The current document result (no decision yet)",
      "basis": "Basis",
      "basis_document": "Document checked",
      "basis_exempt": "Exempt by the declared country",
      "basis_not_required": "Not required when decided",
      "basis_pre_document": "Decided before the document step existed",
      "basis_manual": "Verified manually",
      "status": "Status",
      "status_checked": "Checked",
      "status_not_checked": "Not checked",
      "status_stale": "Out of date",
      "status_verified_manually": "Verified manually",
      "method": "Method",
      "method_provider": "Provider",
      "method_video_call": "Video call",
      "day": "Checked on",
      "policyVersion": "Policy version",
      "name": "First name",
      "nameNone": "No name on record.",
      "birthYear": "Birth year",
      "script_latin": "Latin script",
      "script_hebrew": "Hebrew script",
      "script_arabic": "Arabic script",
      "script_other": "Other script",
      "provenance_printed": "as printed",
      "provenance_transliterated": "transliterated",
      "provenance_typed": "typed by the voter",
      "provenance_manual": "confirmed by an admin",
      "answer_confirmed": "The voter confirmed it",
      "answer_disputed": "The voter says it is wrong",
      "providerDecision": "Provider decision",
      "provider": "Provider",
      "decision_accept": "Accept",
      "decision_review": "Review",
      "checks": "Checks",
      "checkLine": "{{name}}: {{state}}",
      "face": "Face against the document portrait",
      "band_match": "Match",
      "band_document_face_uncertain": "Uncertain",
      "band_document_face_mismatch": "No match",
      "band_none": "Not compared",
      "score": "Score {{value}}",
      "reasons": "Document reasons",
      "anchorReasons": "First face check reasons",
      "stickyReasons": "Unresolved",
      "noReasons": "None",
      "versions": "Versions",
      "versionsLine": "Policy {{policy}} · consent {{consent}} · bands {{bands}} · quality {{quality}} · model {{model}}",
      "unknown": "unknown",
      "matrixRow": "Automatic approval record",
      "auto": "Automatic approval",
      "autoGiven": "Given (matrix record {{record}})",
      "autoNot": "Not automatic because:",
      "blocker_face_decision_reasons": "The face step needs review: {{reasons}}",
      "blocker_face_decision_reasons_unrecorded": "Face step reasons at the time: not recorded",
      "blocker_document_sticky": "Unresolved adverse outcome: {{reasons}}",
      "blocker_document_sticky_unrecorded": "Unresolved adverse outcomes at the time: not recorded",
      "blocker_no_selection": "No recorded document choice",
      "blocker_no_selection_unrecorded": "Document choice: not recorded (the try is gone)",
      "blocker_face_band_not_match": "Face is not a match with the document portrait ({{band}})",
      "blocker_document_reasons": "Document reasons: {{reasons}}",
      "blocker_provider_not_accept": "The provider sent the document to review",
      "blocker_name_not_confirmed": "The voter says the document name is wrong",
      "blocker_age_not_confirmed": "The document does not confirm age 17 or over",
      "blocker_age_not_confirmed_unrecorded": "Age 17 or over: not recorded",
      "blocker_check_failed": "{{check}} check failed",
      "blocker_check_not_passed_not_run": "{{check}} check not run by the provider",
      "blocker_check_not_passed_unknown": "{{check}} check result unknown",
      "blocker_check_not_passed_not_applicable": "{{check}} check marked not applicable, but required",
      "blocker_no_matrix_row_document": "No assurance-matrix row for this document, document provider and liveness provider",
      "blocker_no_matrix_row_not_recognised": "The provider did not recognise the chosen document",
      "blocker_no_matrix_row_not_recognised_unrecorded": "Document recognised as chosen: not recorded",
      "blocker_no_matrix_row_liveness_method": "No assurance-matrix row for this liveness method",
      "blocker_no_matrix_row_combination": "No single assurance-matrix row allows this combination",
      "blocker_liveness_method_missing": "No liveness method recorded",
      "blocker_liveness_below_floor": "Liveness score {{value}} is below {{floor}}",
      "blocker_liveness_below_floor_none": "No liveness score (needs {{floor}})",
      "blocker_face_below_floor": "Face match {{value}} is below {{floor}}",
      "blocker_face_below_floor_none": "No face match score (needs {{floor}})",
      "blocker_bands_version": "Checked with face bands the matrix does not name",
      "blocker_not_recorded": "The reason was not recorded at the time",
      "blocker_other": "Another reason",
      "exemption": "Exemption",
      "exemptionLine": "{{state}} · rule {{rule}} · {{level}} level · policy {{version}} · {{at}}",
      "exemption_current": "Current",
      "exemption_consumed": "Used",
      "exemption_invalidated": "No longer valid",
      "level_area": "area",
      "level_region": "region",
      "level_country": "country",
      "conditionLine": "{{name}}: {{state}}",
      "conditionYes": "Held",
      "conditionNo": "Did not hold",
      "anchor": "First face reference",
      "anchor_present": "Stored",
      "anchor_missing": "Missing",
      "anchorBasis_document": "from the document",
      "anchorBasis_exempt": "from an exempt registration",
      "anchorBasis_not_required": "from a registration without a document",
      "anchorBasis_pre_document": "from before the document step",
      "anchorBasis_manual": "from a video call",
      "anchorLine": "{{state}} {{basis}} · model {{model}} · version {{version}}",
      "manual": "Verified manually",
      "manualLine": "Video call, by {{who}}, {{at}}",
      "manualWho": "an admin who has since left",
      "manualResolved": "Resolved: {{reasons}}",
      "consent": "Document consent",
      "consentLine": "{{at}} · version {{version}} · {{provider}}",
      "consentNone": "Not given",
      "evidence": "Document result kept",
      "evidenceCurrent": "Kept until {{at}}",
      "evidenceScannedGone": "Scanned, but the result is gone",
      "evidenceNone": "None",
      "attempts": "Document tries",
      "attemptsLine": "{{counted}} of {{max}} counted"
    },
    "verify": {
      "title": "Verified manually",
      "body": "Use this only after a supervised video call in which you saw the person and their original document.",
      "resolves": "This closes: {{reasons}}",
      "approves": "No other reason is left, so the voter is approved and told by email.",
      "staysInReview": "Other reasons are left, so the voter stays in review.",
      "tick": "I verified this person and their original document by video call",
      "nameLabel": "First name for the record",
      "nameHelp": "Optional. Only the first name is saved.",
      "confirm": "Verified manually"
    },
    "docProviders": {
      "title": "Document providers",
      "intro": "Providers that read identity documents. They are separate from the face-check providers above.",
      "cardLabel": "{{name}} (document provider)",
      "pending": "Open tries at the provider: {{count}}",
      "overdue_one": "{{count}} deletion overdue (more than 7 days)",
      "overdue_other": "{{count}} deletions overdue (more than 7 days)",
      "overdueNone": "No deletions overdue",
      "lastWebhook": "Last webhook: {{date}}",
      "webhookNever": "No webhook received yet",
      "retentionMonths_one": "Provider keeps data for {{count}} month",
      "retentionMonths_other": "Provider keeps data for {{count}} months",
      "retentionUnset": "Provider retention is not set (it must be 2 months or less)",
      "retentionTooLong": "Provider keeps data for {{count}} months: more than 2",
      "retentionChecked": "read {{date}}",
      "retentionNone": "Retention not read yet: check health",
      "checkHealth": "Check health",
      "checkHealthLabel": "Check health ({{name}})",
      "enabledLabel": "Enabled",
      "alarm": "Alarm"
    }
  },
  "bioid": {
    "nod": "Now move your head a little when we ask. Nod your head slightly, down and up, just once and slowly.",
    "moveLeft": "Move your head slowly to the left.",
    "moveRight": "Move your head slowly to the right.",
    "moveUp": "Move your head slowly up.",
    "moveDown": "Move your head slowly down.",
    "admin": {
      "mode": "Check mode",
      "modeHelp": "Passive: one picture. Active: two pictures, the second after a small nod. Challenge: as active, and the person moves the head the way our server chooses.",
      "passive": "Passive (one picture)",
      "active": "Active (two pictures, a small nod)",
      "challenge": "Challenge (two pictures, a direction we choose)",
      "thresholdDesktop": "Motion trigger on computers (%)",
      "thresholdDesktopHelp": "How much the head must move, in percent of the largest movement, before the second picture is taken. BioID uses 25.",
      "thresholdMobile": "Motion trigger on phones (%)",
      "thresholdMobileHelp": "The same on phones and tablets. BioID uses 50.",
      "loggingOff": "Image logging and support monitoring are off in the BWS Portal",
      "loggingOffHelp": "Switch this on only after you checked the client in the BWS Portal (image logging and support monitoring off). BioID cannot be enabled before. The change is recorded in the audit log."
    }
  },
  "testProvider": {
    "bannerTitle": "Test only. For our staff, not for voters.",
    "bannerText": "This link uses a test check from {{provider}}. Use it only if you work with us and agreed to test it. Do not use your real registration here. If you want to register as a voter, use this link instead:",
    "bannerAfter": "After the test",
    "bannerDelete": "After the test, delete this test registration (on your voter page, or ask the person who runs the test).",
    "aboutFace1": "This is a <b>test check</b>. We send your face scan to {{provider}}, a company in the USA. {{provider}} may keep it and use it to improve its software. We cannot delete it there.",
    "aboutFace2": "After the {{provider}} check, our own camera screen takes one more picture of you. We send it to {{provider}} too, to check that it is the same person. Our system makes your face template from <b>this picture</b>, not from {{provider}}, and then deletes the picture, unless a person has to review your registration (see below).",
    "consent": "I work with {{org}} and I agree to test this check. I understand that this is a test provider: my face scan is sent to {{provider}} in the USA, which may use it to improve its software, and it cannot be deleted there. I agree that {{org}} keeps my face template (not a photo) until I delete this test registration. If a person has to review it, {{org}} also keeps the photo of my face check and the photos of my document until the review ends, at the latest {{days}} days after the review starts.",
    "handover": "The test check of {{provider}} opens on a new page, on this phone or computer. It uses your camera. It takes about half a minute. Then you come back here, and we take one more picture.",
    "tipPhone": "On a phone, hold it upright, in front of your face. The check will ask you to move the phone a little closer.",
    "tipComputer": "On a computer, sit in front of the screen and look at it.",
    "start": "Start the test check",
    "stillTitle": "One more picture",
    "stillLine": "Look at the camera. We take one picture to check that it is you.",
    "stillNotMatched": "Let's take the picture again. Come a little closer and look straight at the camera.",
    "adminBadge": "Test provider (staff only)",
    "adminNotice": "Test provider (staff only). Allowed on this deployment by FACETEC_TESTING_ALLOWED."
  },
  "facetec": {
    "pageTitle": "Test check by FaceTec",
    "loading": "Getting the check ready... This can take a few seconds on older phones.",
    "success": "Thank you. Now one more picture.",
    "stopped": "You stopped the check.",
    "lockedOut": "The check stopped after many tries. Please wait a few minutes and try again.",
    "cameraDenied": "The check could not use your camera. Please allow the camera for this site in your browser, then go back and try again. This did not count as a try.",
    "notInstalled": "This test check is not available right now. This did not count as a try. Please tell the person who runs the test.",
    "firefoxAndroid": "This check does not work in Firefox on Android. Please continue in Chrome: press \"Help\", then \"Email me a link to continue\", and open that email in Chrome. This did not count as a try.",
    "failed": "Something went wrong during the check. This did not count as a try. Please go back and try again in a few minutes.",
    "goBack": "Go back",
    "bindPassLevel": "Match level to pass (0-7)",
    "bindPassLevelHelp": "FaceTec's 3D:2D match level of our picture against the live scan. 6 is 1 in 100,000 false accepts, 7 is 1 in 500,000.",
    "bindReviewLevel": "Match level for review (0-7)",
    "bindReviewLevelHelp": "From this level up to the pass level a person reviews the registration. Below it the voter takes the picture again.",
    "maxStills": "Pictures per check (1-3)",
    "maxStillsHelp": "How many times our picture may be taken again before the check ends without a decision.",
    "sdk": {
      "FaceTec_presession_frame_your_face": "Frame your face in the oval",
      "FaceTec_presession_look_straight_ahead": "Look straight ahead",
      "FaceTec_presession_eyes_straight_ahead": "Look straight ahead",
      "FaceTec_presession_brighten_your_environment": "Find more light",
      "FaceTec_presession_remove_dark_glasses": "Take off your dark glasses",
      "FaceTec_presession_neutral_expression": "Neutral face, no smiling",
      "FaceTec_presession_conditions_too_bright": "Too bright here",
      "FaceTec_feedback_center_face": "Put your face in the middle",
      "FaceTec_feedback_face_not_found": "Frame your face in the oval",
      "FaceTec_feedback_move_phone_away": "Move a little away",
      "FaceTec_feedback_move_phone_closer": "Move closer",
      "FaceTec_feedback_move_away_web": "Move a little away",
      "FaceTec_feedback_move_web_closer": "Move closer and fill the oval",
      "FaceTec_feedback_move_web_even_closer": "Even closer",
      "FaceTec_feedback_move_to_eye_level_web": "Look straight into the camera",
      "FaceTec_feedback_hold_steady": "Hold steady",
      "FaceTec_feedback_use_even_lighting": "Find more even light",
      "FaceTec_feedback_face_not_looking_straight_ahead": "Look straight ahead",
      "FaceTec_feedback_face_not_upright": "Hold your head straight",
      "FaceTec_feedback_face_not_upright_mobile": "Hold your head straight",
      "FaceTec_result_facescan_upload_message": "Checking...",
      "FaceTec_result_facescan_upload_message_still_uploading": "Still checking... The connection is slow",
      "FaceTec_result_facescan_success_3d_enrollment_message": "Done",
      "FaceTec_retry_header": "Let's try that again",
      "FaceTec_retry_subheader_message": "Look straight at the camera, in even light",
      "FaceTec_retry_your_image_label": "Your picture",
      "FaceTec_retry_ideal_image_label": "Good position",
      "FaceTec_retry_instruction_message_1": "Look straight ahead, in even light",
      "FaceTec_retry_instruction_message_2": "Neutral face, no smiling",
      "FaceTec_retry_instruction_message_3": "Too blurry. Clean the camera",
      "FaceTec_action_im_ready": "I am ready",
      "FaceTec_action_try_again": "Try again",
      "FaceTec_action_continue": "Continue",
      "FaceTec_instructions_header_ready_desktop": "Get ready for a short video of your face",
      "FaceTec_instructions_header_ready_1_mobile": "Get ready for",
      "FaceTec_instructions_header_ready_2_mobile": "a short video of your face",
      "FaceTec_instructions_message_ready_desktop": "Put your face in the oval, press I am ready, and move closer",
      "FaceTec_instructions_message_ready_1_mobile": "Put your face in the oval,",
      "FaceTec_instructions_message_ready_2_mobile": "press I am ready, and move closer",
      "FaceTec_camera_permission_header": "Allow the camera",
      "FaceTec_camera_permission_message": "The check needs your camera. Please allow it.",
      "FaceTec_accessibility_cancel_button": "Stop the check",
      "FaceTec_accessibility_tap_guidance": "Double tap the screen for help to place your face",
      "FaceTec_accessibility_key_down_guidance": "Press Enter or the space bar for help to place your face",
      "FaceTec_accessibility_feedback_move_phone_away": "Your face is too close",
      "FaceTec_accessibility_feedback_move_phone_closer": "Your face is too far away",
      "FaceTec_accessibility_feedback_face_too_far_left": "Your face is too far to the left",
      "FaceTec_accessibility_feedback_face_too_far_right": "Your face is too far to the right",
      "FaceTec_accessibility_feedback_face_too_low": "Your face is too low",
      "FaceTec_accessibility_feedback_face_too_high": "Your face is too high",
      "FaceTec_accessibility_feedback_face_rotated_too_far_left": "Your face is turned too far to the left",
      "FaceTec_accessibility_feedback_face_rotated_too_far_right": "Your face is turned too far to the right",
      "FaceTec_accessibility_feedback_face_looking_too_far_left": "Your face points too far to the left",
      "FaceTec_accessibility_feedback_face_looking_too_far_right": "Your face points too far to the right",
      "FaceTec_accessibility_feedback_face_not_in_camera": "Your face is not on the camera",
      "FaceTec_accessibility_feedback_hold_phone_to_eye_level": "Hold the phone at the height of your eyes",
      "FaceTec_accessibility_feedback_move_away_web": "Your face is too close",
      "FaceTec_accessibility_feedback_move_closer_web": "Your face is too far away",
      "FaceTec_accessibility_feedback_hold_to_eye_level_web": "Move the camera to the height of your eyes",
      "FaceTec_initializing_camera": "Starting the camera...",
      "FaceTec_result_session_abort_message": "Something went wrong. The check stopped"
    }
  }
}
